

/***  
 *==========================
 * default code start
 * =======================
 * */
// import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
// import PaginatedList from '@theme/paginated-list';

// /**
//  * A custom element that renders a pagniated results list
//  */
// export default class ResultsList extends PaginatedList {
//   connectedCallback() {
//     super.connectedCallback();

//     mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
//     this.setAttribute('initialized', '');
//   }

//   disconnectedCallback() {
//     mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
//   }

//   /**
//    * Updates the layout.
//    *
//    * @param {Event} event
//    */
//   updateLayout({ target }) {
//     if (!(target instanceof HTMLInputElement)) return;

//     this.#animateLayoutChange(target.value);
//   }

//   /**
//    * Sets the layout.
//    *
//    * @param {string} value
//    */
//   #animateLayoutChange = async (value) => {
//     const { grid } = this.refs;

//     if (!grid) return;

//     await startViewTransition(() => this.#setLayout(value), ['product-grid']);

//     requestIdleCallback(() => {
//       const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
//       sessionStorage.setItem(`product-grid-view-${viewport}`, value);
//     });
//   };

//   /**
//    * Animates the layout change.
//    *
//    * @param {string} value
//    */
//   #setLayout(value) {
//     const { grid } = this.refs;
//     if (!grid) return;
//     grid.setAttribute('product-grid-view', value);
//   }

//   /**
//    * Handles the media query change event.
//    *
//    * @param {MediaQueryListEvent} event
//    */
//   #handleMediaQueryChange = (event) => {
//     const targetElement = event.matches
//       ? this.querySelector('[data-grid-layout="desktop-default-option"]')
//       : this.querySelector('[data-grid-layout="mobile-option"]');

//     if (!(targetElement instanceof HTMLInputElement)) return;

//     targetElement.checked = true;
//     this.#setLayout('default');
//   };
// }

// if (!customElements.get('results-list')) {
//   customElements.define('results-list', ResultsList);
// }


/***  
 *==========================
 * default code end
 * =======================
 * */


// import {
// mediaQueryLarge,
//   requestIdleCallback,
//   startViewTransition
// } from '@theme/utilities';

// import PaginatedList from '@theme/paginated-list';

// export default class ResultsList extends PaginatedList {
//   #observer = null;
//   #isLoading = false;
//   #hasNextPage = true;
//   #sentinel = null;
//   #totalPages = 1;
//   #currentPage = 1;
//   #loadingIndicator = null;

//   // ============================================================
//   // API MODE
//   // ============================================================

//   #isApiMode = false;

//   #allProducts = [];
//   #filteredProducts = [];

//   #apiCurrentIndex = 0;
//   #productsPerPage = 24;

//   #apiLoading = false;
//   #apiInitialized = false;

//   #totalFilteredCount = 0;

//   #mutationObserver = null;

//   #filterRequestId = 0;

//   // Shopify Storefront API
//   #storefrontToken = '4ad8b04521da1ae814c71dfe5acc0a50';
//   #storeDomain = '0e03ht-p0.myshopify.com';

//   // ============================================================
//   // LIFECYCLE
//   // ============================================================

//   connectedCallback() {
//     super.connectedCallback();

//     mediaQueryLarge.addEventListener(
//       'change',
//       this.#handleMediaQueryChange
//     );

//     this.setAttribute('initialized', '');

//     this.#createLoadingIndicator();

//     this.#setupMutationObserver();

//     window.addEventListener(
//       'popstate',
//       this.#handleUrlChange
//     );

//     document.addEventListener(
//       'filter-update',
//       this.#handleFilterUpdate
//     );

//     document.addEventListener(
//       'shopify:section:load',
//       this.#handleSectionLoad
//     );

//     /*
//      * Wait until Horizon has finished creating the grid.
//      */
//     requestAnimationFrame(() => {
//       setTimeout(() => {
//         this.#checkFiltersAndInit();
//       }, 100);
//     });
//   }

//   disconnectedCallback() {
//     mediaQueryLarge.removeEventListener(
//       'change',
//       this.#handleMediaQueryChange
//     );

//     window.removeEventListener(
//       'popstate',
//       this.#handleUrlChange
//     );

//     document.removeEventListener(
//       'filter-update',
//       this.#handleFilterUpdate
//     );

//     document.removeEventListener(
//       'shopify:section:load',
//       this.#handleSectionLoad
//     );

//     this.#cleanupSentinel();

//     if (this.#mutationObserver) {
//       this.#mutationObserver.disconnect();
//       this.#mutationObserver = null;
//     }

//     if (
//       this.#loadingIndicator &&
//       this.#loadingIndicator.parentNode
//     ) {
//       this.#loadingIndicator.remove();
//     }
//   }

//   // ============================================================
//   // PUBLIC METHODS
//   // ============================================================

//   reInitFilters() {
//     console.log('🔄 ResultsList: reInitFilters');

//     this.#resetAndInitialize();

//     if (window.customCategoryFilters?.reInit) {
//       setTimeout(() => {
//         window.customCategoryFilters.reInit();
//       }, 100);
//     }
//   }

//   updateProductCount() {
//     return this.#updateProductCount();
//   }

//   // ============================================================
//   // URL / FILTER EVENTS
//   // ============================================================

//   #handleUrlChange = () => {
//     console.log('🔄 URL changed');

//     clearTimeout(this.#urlChangeTimer);

//     this.#urlChangeTimer = setTimeout(() => {
//       this.#resetAndInitialize();
//     }, 100);
//   };

//   #urlChangeTimer = null;

//   #handleFilterUpdate = () => {
//     console.log('🔄 Filter update event');

//     clearTimeout(this.#filterUpdateTimer);

//     this.#filterUpdateTimer = setTimeout(() => {
//       this.#resetAndInitialize();
//     }, 150);
//   };

//   #filterUpdateTimer = null;

//   #handleSectionLoad = () => {
//     console.log('🔄 Shopify section loaded');

//     setTimeout(() => {
//       this.#resetAndInitialize();

//       if (window.customCategoryFilters?.reInit) {
//         window.customCategoryFilters.reInit();
//       }
//     }, 300);
//   };

//   // ============================================================
//   // INITIALIZATION
//   // ============================================================

//   #checkFiltersAndInit() {
//     const filters = this.#getFilterState();

//     console.log('========================================');
//     console.log('🔍 RESULTS LIST INITIALIZATION');
//     console.log('Collection:', this.#getCurrentCollectionHandle());
//     console.log('Filter state:', filters);
//     console.log('========================================');

//     /*
//      * IMPORTANT:
//      *
//      * We use API mode whenever custom measurement filters
//      * are active.
//      *
//      * Shopify's normal filter system remains responsible for
//      * standard filters when measurements are NOT active.
//      *
//      * When measurements ARE active, we fetch the complete
//      * collection using cursor pagination and apply all filters
//      * consistently before rendering.
//      */

//     if (filters.hasMeasurementFilters) {
//       console.log('🔧 Measurement filter detected → API MODE');

//       this.#isApiMode = true;

//       this.#setupApiMode();

//       return;
//     }

//     /*
//      * No measurement filter:
//      *
//      * Let Horizon/Shopify handle normal filtering and use
//      * Horizon's native pagination/infinite scroll.
//      */
//     console.log('📄 No measurement filter → NORMAL MODE');

//     this.#isApiMode = false;

//     window.customFilterUsed = false;

//     this.#hideCustomFilterButtons();

//     this.#initInfiniteScroll();
//   }

//   #resetAndInitialize() {
//     console.log('♻️ Resetting ResultsList');

//     this.#filterRequestId++;

//     this.#apiLoading = false;
//     this.#apiInitialized = false;

//     this.#allProducts = [];
//     this.#filteredProducts = [];

//     this.#apiCurrentIndex = 0;
//     this.#totalFilteredCount = 0;

//     this.#cleanupSentinel();

//     /*
//      * IMPORTANT:
//      *
//      * Do NOT clear the grid here unconditionally.
//      *
//      * For non-measurement filters (category, subcategory, price,
//      * tag-based Search & Discovery facets, ...) Shopify's native
//      * sectionRenderer has already replaced the grid with the
//      * correctly server-rendered products. Wiping it here removed
//      * that correct content and left the grid blank until the next
//      * scroll-triggered page load, which is what caused the
//      * show -> hide -> (only after scrolling) show-filtered glitch.
//      *
//      * Only API mode (measurement filters) needs a full grid wipe,
//      * and #setupApiMode() already takes care of that itself before
//      * it fetches and renders the filtered product set.
//      */
//     this.#checkFiltersAndInit();
//   }

//   // ============================================================
//   // MUTATION OBSERVER
//   // ============================================================

//   #setupMutationObserver() {
//     const grid = this.#findGrid();

//     if (!grid) {
//       setTimeout(() => {
//         this.#setupMutationObserver();
//       }, 500);

//       return;
//     }

//     if (this.#mutationObserver) {
//       this.#mutationObserver.disconnect();
//     }

//     /*
//      * IMPORTANT:
//      *
//      * Do NOT re-apply filters whenever a product is added.
//      *
//      * That was one of the causes of your previous issue.
//      *
//      * API mode already inserts filtered products.
//      */
//     this.#mutationObserver = new MutationObserver(() => {
//       // Intentionally empty.
//       //
//       // We observe only so the component knows the grid exists.
//       // We do NOT modify newly inserted products here.
//     });

//     this.#mutationObserver.observe(grid, {
//       childList: true,
//       subtree: true
//     });
//   }

//   // ============================================================
//   // FILTER STATE
//   // ============================================================

//   #getFilterState() {
//     const params = new URLSearchParams(
//       window.location.search
//     );

//     const getValues = (key) => {
//       return params
//         .getAll(key)
//         .map(value => value.trim())
//         .filter(Boolean);
//     };

//     const widthMin = params.get('filter.p.width_min');
//     const widthMax = params.get('filter.p.width_max');

//     const heightMin = params.get('filter.p.height_min');
//     const heightMax = params.get('filter.p.height_max');

//     const depthMin = params.get('filter.p.depth_min');
//     const depthMax = params.get('filter.p.depth_max');

//     const hasMeasurementFilters =
//       !!widthMin ||
//       !!widthMax ||
//       !!heightMin ||
//       !!heightMax ||
//       !!depthMin ||
//       !!depthMax;

//     return {
//       params,

//       widthMin,
//       widthMax,

//       heightMin,
//       heightMax,

//       depthMin,
//       depthMax,

//       hasMeasurementFilters,

//       priceMin: params.get('filter.v.price.gte'),
//       priceMax: params.get('filter.v.price.lte'),

//       availability: getValues(
//         'filter.v.availability'
//       ),

//       vendors: getValues(
//         'filter.p.vendor'
//       ),

//       productTypes: getValues(
//         'filter.p.product_type'
//       ),

//       categories: getValues(
//         'filter.p.categorie'
//       ),

//       subcategories: getValues(
//         'filter.p.subcategorie'
//       ),

//       designers: getValues(
//         'filter.p.m.custom.designer'
//       ),

//       materials: getValues(
//         'filter.p.m.custom.metarials'
//       ),

//       featured: getValues(
//         'filter.p.m.custom.featured'
//       ),

//       customCategories: getValues(
//         'filter.p.m.custom.categories'
//       ),

//       customSubcategories: getValues(
//         'filter.p.m.custom.subcategories'
//       )
//     };
//   }

//   #getAllFilters() {
//     const params = new URLSearchParams(
//       window.location.search
//     );

//     const filters = {};

//     for (const [key, value] of params.entries()) {
//       if (!key.startsWith('filter.')) {
//         continue;
//       }

//       if (!filters[key]) {
//         filters[key] = [];
//       }

//       filters[key].push(value);
//     }

//     return filters;
//   }

//   // ============================================================
//   // COLLECTION
//   // ============================================================

//   #getCurrentCollectionHandle() {
//     const collectionElement =
//       document.querySelector(
//         '[data-collection-handle]'
//       );

//     if (
//       collectionElement?.dataset?.collectionHandle
//     ) {
//       return collectionElement.dataset.collectionHandle;
//     }

//     const attributeHandle =
//       this.getAttribute('collection-handle');

//     if (attributeHandle) {
//       return attributeHandle;
//     }

//     const pathParts =
//       window.location.pathname
//         .split('/')
//         .filter(Boolean);

//     const collectionIndex =
//       pathParts.indexOf('collections');

//     if (
//       collectionIndex !== -1 &&
//       pathParts[collectionIndex + 1]
//     ) {
//       return pathParts[collectionIndex + 1];
//     }

//     return 'all';
//   }

//   // ============================================================
//   // API MODE
//   // ============================================================

//   #setupApiMode() {
//     const filters = this.#getFilterState();
//     // window.__resultsListApiMode = true;

//     window.customFilterUsed =
//       filters.hasMeasurementFilters;

//     window.priceFilterUsed =
//       !!filters.priceMin ||
//       !!filters.priceMax;

//     this.#showCustomFilterButtons(filters);

//     const pagination = document.querySelector(
//       '.pagination, [data-pagination-wrapper]'
//     );

//     if (pagination) {
//       pagination.style.display = 'none';
//     }

//     this.#cleanupSentinel();

//     this.#clearApiGrid();

//     this.#allProducts = [];
//     this.#filteredProducts = [];

//     this.#apiCurrentIndex = 0;
//     this.#totalFilteredCount = 0;

//     this.#fetchAllProductsWithCursor();
//   }

//   // ============================================================
//   // FETCH ALL PRODUCTS
//   // ============================================================

//   async #fetchAllProductsWithCursor() {
//     if (this.#apiLoading) {
//       return;
//     }

//     this.#apiLoading = true;

//     const requestId =
//       ++this.#filterRequestId;

//     this.#showLoading();

//     try {
//       const collectionHandle =
//         this.#getCurrentCollectionHandle();

//       console.log(
//         '📁 Fetching collection:',
//         collectionHandle
//       );

//       let products = [];

//       let cursor = null;

//       let hasNextPage = true;

//       let page = 0;

//       /*
//        * IMPORTANT:
//        *
//        * Shopify collection/all can contain more than 250 products.
//        *
//        * We therefore use cursor pagination.
//        */
//       while (hasNextPage) {
//         page++;

//         if (
//           requestId !== this.#filterRequestId
//         ) {
//           console.log(
//             '🛑 Old API request cancelled'
//           );

//           return;
//         }

//         console.log(
//           `📥 API page ${page}`
//         );

//         const query =
//           this.#buildProductsQuery(
//             collectionHandle,
//             cursor
//           );

//         const response = await fetch(
//           `https://${this.#storeDomain}/api/2024-04/graphql.json`,
//           {
//             method: 'POST',

//             headers: {
//               'Content-Type':
//                 'application/json',

//               'X-Shopify-Storefront-Access-Token':
//                 this.#storefrontToken
//             },

//             body: JSON.stringify({
//               query
//             })
//           }
//         );

//         if (!response.ok) {
//           throw new Error(
//             `Shopify API HTTP ${response.status}`
//           );
//         }

//         const result =
//           await response.json();

//         if (result.errors?.length) {
//           console.error(
//             'Shopify GraphQL errors:',
//             result.errors
//           );

//           throw new Error(
//             result.errors[0]?.message ||
//             'Shopify API error'
//           );
//         }

//         // const connection =
//         //   collectionHandle &&
//         //   collectionHandle !== 'all'
//         //     ? result.data?.collection?.products
//         //     : result.data?.products;
//         const connection =
//           collectionHandle
//             ? result.data?.collection?.products
//             : result.data?.products;

//         if (!connection) {
//           throw new Error(
//             'No product connection returned by Shopify'
//           );
//         }

//         const edges =
//           connection.edges || [];

//         products.push(
//           ...edges
//         );

//         hasNextPage =
//           !!connection.pageInfo?.hasNextPage;

//         cursor =
//           connection.pageInfo?.endCursor ||
//           null;

//         console.log(
//           `📦 Received ${edges.length} products`
//         );

//         console.log(
//           `📊 Total fetched: ${products.length}`
//         );

//         /*
//          * Safety guard.
//          */
//         if (!cursor && hasNextPage) {
//           console.warn(
//             '⚠️ Shopify returned hasNextPage without cursor'
//           );

//           break;
//         }
//       }

//       if (
//         requestId !== this.#filterRequestId
//       ) {
//         return;
//       }

//       console.log(
//         `✅ Finished fetching ${products.length} products`
//       );

//       this.#allProducts =
//         products.map(edge =>
//           this.#normalizeProduct(
//             edge.node
//           )
//         );

//       /*
//        * Apply EVERY filter before rendering.
//        */
//       this.#applyAllFilters();

//     } catch (error) {
//       console.error(
//         '❌ API error:',
//         error
//       );

//       this.#showErrorMessage(
//         error.message
//       );

//     } finally {
//       this.#apiLoading = false;

//       this.#hideLoading();
//     }
//   }

//   // ============================================================
//   // GRAPHQL QUERY
//   // ============================================================

//   #buildProductsQuery(
//     collectionHandle,
//     cursor
//   ) {
//     const filters =
//       this.#buildShopifyFilters();

//     const after =
//       cursor
//         ? `, after: "${cursor}"`
//         : '';

//     const filterArgument =
//       filters.length
//         ? `, filters: { ${filters.join(', ')} }`
//         : '';

//     const productFields = `
//       id
//       title
//       handle
//       description
//       vendor
//       productType
//       availableForSale

//       priceRange {
//         minVariantPrice {
//           amount
//           currencyCode
//         }
//       }

//       widthValue: metafield(
//         namespace: "custom",
//         key: "measurement_width"
//       ) {
//         value
//       }

//       heightValue: metafield(
//         namespace: "custom",
//         key: "measurement_height"
//       ) {
//         value
//       }

//       depthValue: metafield(
//         namespace: "custom",
//         key: "measurement_depth"
//       ) {
//         value
//       }

//       categories: metafield(
//         namespace: "custom",
//         key: "categories"
//       ) {
//         value
//       }

//       subcategories: metafield(
//         namespace: "custom",
//         key: "subcategories"
//       ) {
//         value
//       }

//       designer: metafield(
//         namespace: "custom",
//         key: "designer"
//       ) {
//         value
//       }

//       materials: metafield(
//         namespace: "custom",
//         key: "metarials"
//       ) {
//         value
//       }

//       featured: metafield(
//         namespace: "custom",
//         key: "featured"
//       ) {
//         value
//       }

//       images(first: 4) {
//         edges {
//           node {
//             url
//             altText
//           }
//         }
//       }

//       collections(first: 50) {
//         edges {
//           node {
//             title
//             handle
//           }
//         }
//       }
//     `;

//     // if (
//     //   collectionHandle &&
//     //   collectionHandle !== 'all'
//     // ) {
//     if (collectionHandle) {
//       return `
//         {
//           collection(
//             handle: "${this.#escapeGraphQL(
//               collectionHandle
//             )}"
//           ) {
//             products(
//               first: 250
//               ${after}
//               ${filterArgument}
//             ) {
//               edges {
//                 node {
//                   ${productFields}
//                 }
//               }

//               pageInfo {
//                 hasNextPage
//                 endCursor
//               }
//             }
//           }
//         }
//       `;
//     }

//     return `
//       {
//         products(
//           first: 250
//           ${after}
//           ${filterArgument}
//         ) {
//           edges {
//             node {
//               ${productFields}
//             }
//           }

//           pageInfo {
//             hasNextPage
//             endCursor
//           }
//         }
//       }
//     `;
//   }

//   // ============================================================
//   // SHOPIFY SERVER FILTERS
//   // ============================================================

//   #buildShopifyFilters() {
//     const filters =
//       this.#getFilterState();

//     const parts = [];

//     /*
//      * PRICE
//      */
//     if (
//       filters.priceMin ||
//       filters.priceMax
//     ) {
//       const min =
//         filters.priceMin
//           ? parseFloat(filters.priceMin)
//           : null;

//       const max =
//         filters.priceMax
//           ? parseFloat(filters.priceMax)
//           : null;

//       if (
//         min !== null &&
//         max !== null
//       ) {
//         parts.push(
//           `price: { min: ${min}, max: ${max} }`
//         );
//       } else if (min !== null) {
//         parts.push(
//           `price: { min: ${min} }`
//         );
//       } else if (max !== null) {
//         parts.push(
//           `price: { max: ${max} }`
//         );
//       }
//     }

//     /*
//      * AVAILABILITY
//      */
//     if (
//       filters.availability.length
//     ) {
//       const available =
//         filters.availability.includes('1') ||
//         filters.availability.includes('true');

//       parts.push(
//         `available: ${available}`
//       );
//     }

//     /*
//      * VENDOR
//      *
//      * Multiple vendor values are handled as OR.
//      */
//     if (
//       filters.vendors.length === 1
//     ) {
//       parts.push(
//         `vendor: "${this.#escapeGraphQL(
//           filters.vendors[0]
//         )}"`
//       );
//     }

//     /*
//      * PRODUCT TYPE
//      */
//     if (
//       filters.productTypes.length === 1
//     ) {
//       parts.push(
//         `productType: "${this.#escapeGraphQL(
//           filters.productTypes[0]
//         )}"`
//       );
//     }

//     /*
//      * VARIANT OPTIONS
//      *
//      * Example:
//      * filter.v.option.color=Red
//      */
//     const params =
//       new URLSearchParams(
//         window.location.search
//       );

//     const optionGroups = {};

//     for (
//       const [key, value] of params.entries()
//     ) {
//       if (
//         !key.startsWith(
//           'filter.v.option.'
//         )
//       ) {
//         continue;
//       }

//       const optionName =
//         key.replace(
//           'filter.v.option.',
//           ''
//         );

//       if (!optionGroups[optionName]) {
//         optionGroups[optionName] = [];
//       }

//       optionGroups[optionName].push(
//         value
//       );
//     }

//     /*
//      * Shopify Storefront API supports one
//      * variantOption filter at a time in this
//      * structure.
//      *
//      * Apply one when present.
//      *
//      * Additional option values are handled
//      * client-side by the browser where needed.
//      */
//     Object.entries(optionGroups)
//       .forEach(
//         ([optionName, values]) => {
//           if (values.length === 1) {
//             parts.push(
//               `variantOption: { name: "${this.#escapeGraphQL(
//                 optionName
//               )}", value: "${this.#escapeGraphQL(
//                 values[0]
//               )}" }`
//             );
//           }
//         }
//       );

//     return parts;
//   }

//   // ============================================================
//   // NORMALIZE PRODUCT
//   // ============================================================

//   #normalizeProduct(node) {
//     return {
//       id: node.id,

//       numericId:
//         node.id?.split('/').pop() || '',

//       title:
//         node.title || '',

//       handle:
//         node.handle || '',

//       description:
//         node.description || '',

//       vendor:
//         node.vendor || '',

//       productType:
//         node.productType || '',

//       availableForSale:
//         !!node.availableForSale,

//       price:
//         parseFloat(
//           node.priceRange
//             ?.minVariantPrice
//             ?.amount || 0
//         ),

//       currency:
//         node.priceRange
//           ?.minVariantPrice
//           ?.currencyCode || 'EUR',

//       width:
//         node.widthValue?.value || '',

//       height:
//         node.heightValue?.value || '',

//       depth:
//         node.depthValue?.value || '',

//       categories:
//         this.#parseMetafield(
//           node.categories?.value
//         ),

//       subcategories:
//         this.#parseMetafield(
//           node.subcategories?.value
//         ),

//       designer:
//         this.#parseMetafield(
//           node.designer?.value
//         ),

//       materials:
//         this.#parseMetafield(
//           node.materials?.value
//         ),

//       featured:
//         this.#parseMetafield(
//           node.featured?.value
//         ),

//       images:
//         node.images || {
//           edges: []
//         },

//       collections:
//         (node.collections?.edges || [])
//           .map(edge => ({
//             title:
//               edge.node?.title || '',

//             handle:
//               edge.node?.handle || ''
//           }))
//     };
//   }

//   // ============================================================
//   // METAFIELD PARSER
//   // ============================================================

//   #parseMetafield(value) {
//     if (
//       value === null ||
//       value === undefined ||
//       value === ''
//     ) {
//       return [];
//     }

//     if (
//       Array.isArray(value)
//     ) {
//       return value
//         .map(String)
//         .map(v => v.trim())
//         .filter(Boolean);
//     }

//     const stringValue =
//       String(value).trim();

//     /*
//      * JSON array
//      */
//     if (
//       stringValue.startsWith('[') &&
//       stringValue.endsWith(']')
//     ) {
//       try {
//         const parsed =
//           JSON.parse(stringValue);

//         if (Array.isArray(parsed)) {
//           return parsed
//             .map(String)
//             .map(v => v.trim())
//             .filter(Boolean);
//         }
//       } catch (error) {
//         // Fall through.
//       }
//     }

//     /*
//      * Comma separated
//      */
//     if (
//       stringValue.includes(',')
//     ) {
//       return stringValue
//         .split(',')
//         .map(v => v.trim())
//         .filter(Boolean);
//     }

//     return [stringValue];
//   }

//   // ============================================================
//   // APPLY ALL FILTERS
//   // ============================================================

//   #applyAllFilters() {
//     const filters =
//       this.#getFilterState();

//     let products =
//       [...this.#allProducts];

//     console.log(
//       '========================================'
//     );

//     console.log(
//       '🔎 APPLYING FILTERS'
//     );

//     console.log(
//       'Products before:',
//       products.length
//     );

//     /*
//      * ==========================================================
//      * MEASUREMENT
//      * ==========================================================
//      */

//     if (
//       filters.widthMin ||
//       filters.widthMax
//     ) {
//       const min =
//         this.#toNumber(
//           filters.widthMin,
//           0
//         );

//       const max =
//         this.#toNumber(
//           filters.widthMax,
//           Infinity
//         );

//       products =
//         products.filter(product => {
//           const value =
//             this.#toNumber(
//               product.width,
//               0
//             );

//           return (
//             value >= min &&
//             value <= max
//           );
//         });

//       console.log(
//         'After width:',
//         products.length
//       );
//     }

//     if (
//       filters.heightMin ||
//       filters.heightMax
//     ) {
//       const min =
//         this.#toNumber(
//           filters.heightMin,
//           0
//         );

//       const max =
//         this.#toNumber(
//           filters.heightMax,
//           Infinity
//         );

//       products =
//         products.filter(product => {
//           const value =
//             this.#toNumber(
//               product.height,
//               0
//             );

//           return (
//             value >= min &&
//             value <= max
//           );
//         });

//       console.log(
//         'After height:',
//         products.length
//       );
//     }

//     if (
//       filters.depthMin ||
//       filters.depthMax
//     ) {
//       const min =
//         this.#toNumber(
//           filters.depthMin,
//           0
//         );

//       const max =
//         this.#toNumber(
//           filters.depthMax,
//           Infinity
//         );

//       products =
//         products.filter(product => {
//           const value =
//             this.#toNumber(
//               product.depth,
//               0
//             );

//           return (
//             value >= min &&
//             value <= max
//           );
//         });

//       console.log(
//         'After depth:',
//         products.length
//       );
//     }

//     /*
//      * ==========================================================
//      * CATEGORY
//      * ==========================================================
//      */

//     if (
//       filters.categories.length
//     ) {
//       products =
//         products.filter(product =>
//           this.#matchesAny(
//             product.categories,
//             filters.categories
//           )
//         );

//       console.log(
//         'After category:',
//         products.length
//       );
//     }

//     /*
//      * ==========================================================
//      * SUBCATEGORY
//      * ==========================================================
//      */

//     if (
//       filters.subcategories.length
//     ) {
//       products =
//         products.filter(product =>
//           this.#matchesAny(
//             product.subcategories,
//             filters.subcategories
//           )
//         );

//       console.log(
//         'After subcategory:',
//         products.length
//       );
//     }

//     /*
//      * ==========================================================
//      * CUSTOM CATEGORY
//      * ==========================================================
//      */

//     if (
//       filters.customCategories.length
//     ) {
//       products =
//         products.filter(product =>
//           this.#matchesAny(
//             product.categories,
//             filters.customCategories
//           )
//         );
//     }

//     /*
//      * ==========================================================
//      * CUSTOM SUBCATEGORY
//      * ==========================================================
//      */

//     if (
//       filters.customSubcategories.length
//     ) {
//       products =
//         products.filter(product =>
//           this.#matchesAny(
//             product.subcategories,
//             filters.customSubcategories
//           )
//         );
//     }

//     /*
//      * ==========================================================
//      * DESIGNER
//      * ==========================================================
//      */

//     if (
//       filters.designers.length
//     ) {
//       products =
//         products.filter(product =>
//           this.#matchesAny(
//             [
//               ...product.designer,
//               ...product.collections
//                 .map(c => c.title)
//             ],
//             filters.designers
//           )
//         );
//     }

//     /*
//      * ==========================================================
//      * MATERIAL
//      * ==========================================================
//      */

//     if (
//       filters.materials.length
//     ) {
//       products =
//         products.filter(product =>
//           this.#matchesAny(
//             product.materials,
//             filters.materials
//           )
//         );
//     }

//     /*
//      * ==========================================================
//      * FEATURED
//      * ==========================================================
//      */

//     if (
//       filters.featured.length
//     ) {
//       products =
//         products.filter(product =>
//           this.#matchesAny(
//             product.featured,
//             filters.featured
//           )
//         );
//     }

//     /*
//      * ==========================================================
//      * PRICE
//      *
//      * Price is also checked client-side.
//      *
//      * This protects against any mismatch between
//      * Shopify's API response and URL state.
//      * ==========================================================
//      */

//     if (
//       filters.priceMin ||
//       filters.priceMax
//     ) {
//       const min =
//         this.#toNumber(
//           filters.priceMin,
//           0
//         );

//       const max =
//         this.#toNumber(
//           filters.priceMax,
//           Infinity
//         );

//       products =
//         products.filter(product =>
//           product.price >= min &&
//           product.price <= max
//         );

//       console.log(
//         'After price:',
//         products.length
//       );
//     }

//     /*
//      * ==========================================================
//      * AVAILABILITY
//      * ==========================================================
//      */

//     if (
//       filters.availability.length
//     ) {
//       const wantsAvailable =
//         filters.availability.includes('1') ||
//         filters.availability.includes('true');

//       products =
//         products.filter(product =>
//           wantsAvailable
//             ? product.availableForSale
//             : true
//         );
//     }

//     this.#filteredProducts =
//       products;

//     this.#totalFilteredCount =
//       products.length;

//     console.log(
//       '========================================'
//     );

//     console.log(
//       '✅ FINAL PRODUCTS:',
//       this.#totalFilteredCount
//     );

//     console.log(
//       '========================================'
//     );

//     this.#renderFilteredProducts();
//   }

//   // ============================================================
//   // MATCH HELPERS
//   // ============================================================

//   #matchesAny(
//     productValues,
//     filterValues
//   ) {
//     const products =
//       (productValues || [])
//         .map(value =>
//           this.#normalizeValue(value)
//         );

//     const filters =
//       (filterValues || [])
//         .map(value =>
//           this.#normalizeValue(value)
//         );

//     return filters.some(filter =>
//       products.includes(filter)
//     );
//   }

//   #normalizeValue(value) {
//     return String(value || '')
//       .trim()
//       .toLowerCase()
//       .replace(/\s+/g, ' ');
//   }

//   #toNumber(value, fallback) {
//     if (
//       value === null ||
//       value === undefined ||
//       value === ''
//     ) {
//       return fallback;
//     }

//     const number =
//       parseFloat(
//         String(value)
//           .replace(',', '.')
//           .replace(/[^\d.-]/g, '')
//       );

//     return Number.isFinite(number)
//       ? number
//       : fallback;
//   }

//   // ============================================================
//   // RENDER
//   // ============================================================

//   #renderFilteredProducts() {
//     const grid =
//       this.#findGrid();

//     if (!grid) {
//       console.error(
//         '❌ Product grid not found'
//       );

//       return;
//     }

//     this.#cleanupSentinel();

//     this.#clearGridProducts();

//     this.#apiCurrentIndex = 0;

//     if (
//       this.#filteredProducts.length === 0
//     ) {
//       this.#showNoResults();

//       this.#updateProductCount();

//       return;
//     }

//     /*
//      * Render ONLY filtered products.
//      */
//     this.#showNextBatch();

//     this.#updateProductCount();

//     if (
//       this.#apiCurrentIndex <
//       this.#filteredProducts.length
//     ) {
//       setTimeout(() => {
//         this.#setupApiInfiniteScroll();
//       }, 100);
//     }
//   }

//   // ============================================================
//   // API BATCH
//   // ============================================================

//   #showNextBatch() {
//     const grid =
//       this.#findGrid();

//     if (!grid) {
//       return;
//     }

//     const start =
//       this.#apiCurrentIndex;

//     const end =
//       Math.min(
//         start + this.#productsPerPage,
//         this.#filteredProducts.length
//       );

//     const batch =
//       this.#filteredProducts.slice(
//         start,
//         end
//       );

//     console.log(
//       `🎨 Rendering ${start + 1}-${end} of ${this.#filteredProducts.length}`
//     );

//     const existingIds =
//       new Set();

//     grid
//       .querySelectorAll(
//         '.product-card-custom'
//       )
//       .forEach(card => {
//         const id =
//           card.dataset.productId;

//         if (id) {
//           existingIds.add(id);
//         }
//       });

//     let animationIndex = 0;

//     batch.forEach(product => {
//       const productId =
//         product.numericId;

//       /*
//        * Absolute duplicate protection.
//        */
//       if (
//         existingIds.has(productId)
//       ) {
//         return;
//       }

//       const card =
//         this.#createProductCard(
//           product
//         );

//       existingIds.add(productId);

//       card.style.opacity = '0';
//       card.style.transform =
//         'translateY(20px)';

//       card.style.transition =
//         `opacity 0.3s ease ${
//           animationIndex * 0.05
//         }s, transform 0.3s ease ${
//           animationIndex * 0.05
//         }s`;

//       grid.appendChild(card);

//       animationIndex++;

//       requestAnimationFrame(() => {
//         requestAnimationFrame(() => {
//           card.style.opacity = '1';
//           card.style.transform =
//             'translateY(0)';
//         });
//       });
//     });

//     this.#apiCurrentIndex = end;

//     // this.#updateProductCount(); 

//     /*
//      * IMPORTANT:
//      *
//      * There is NO window.applyFilters()
//      * here.
//      *
//      * There is NO category re-filtering
//      * here.
//      *
//      * There is NO measurement re-filtering
//      * here.
//      *
//      * The array was already filtered before
//      * rendering.
//      */

//     if (
//       this.#apiCurrentIndex >=
//       this.#filteredProducts.length
//     ) {
//       this.#cleanupSentinel();

//       this.#showEndMessage();
//     }
//   }

//   // ============================================================
//   // API INFINITE SCROLL
//   // ============================================================

//   #setupApiInfiniteScroll() {
//     this.#cleanupSentinel();

//     if (
//       this.#apiCurrentIndex >=
//       this.#filteredProducts.length
//     ) {
//       return;
//     }

//     const grid =
//       this.#findGrid();

//     if (
//       !grid ||
//       !grid.parentElement
//     ) {
//       return;
//     }

//     const sentinel =
//       document.createElement('div');

//     sentinel.className =
//       'infinite-scroll-sentinel';

//     sentinel.style.cssText = `
//       height: 30px;
//       width: 100%;
//       opacity: 0;
//       pointer-events: none;
//     `;

//     sentinel.dataset.testid =
//       'api-infinite-scroll-sentinel';

//     this.#sentinel = sentinel;

//     grid.parentElement.appendChild(
//       sentinel
//     );

//     this.#observer =
//       new IntersectionObserver(
//         entries => {
//           const visible =
//             entries.some(
//               entry =>
//                 entry.isIntersecting
//             );

//           if (
//             !visible ||
//             this.#apiLoading
//           ) {
//             return;
//           }

//           if (
//             this.#apiCurrentIndex >=
//             this.#filteredProducts.length
//           ) {
//             this.#cleanupSentinel();
//             return;
//           }

//           this.#showNextBatch();

//           if (
//             this.#apiCurrentIndex <
//             this.#filteredProducts.length
//           ) {
//             setTimeout(() => {
//               this.#setupApiInfiniteScroll();
//             }, 50);
//           }
//         },
//         {
//           rootMargin:
//             '0px 0px 500px 0px',

//           threshold: 0.01
//         }
//       );

//     this.#observer.observe(
//       sentinel
//     );
//   }

//   // ============================================================
//   // PRODUCT CARD
//   // ============================================================

//   #createProductCard(product) {
//     const li =
//       document.createElement('li');

//     li.className =
//       'product-card-custom product-grid__item product-grid__item--0';

//     li.dataset.productId =
//       product.numericId;

//     li.dataset.width =
//       product.width || '';

//     li.dataset.height =
//       product.height || '';

//     li.dataset.depth =
//       product.depth || '';

//     li.dataset.priceFilter =
//       String(product.price);

//     li.dataset.currency =
//       product.currency;

//     li.dataset.page = '1';

//     li.setAttribute(
//       'ref',
//       'cards[]'
//     );

//     /*
//      * Keep data attributes available to
//      * your existing category system.
//      */

//     li.dataset.filterCategory =
//       product.categories.join(',');

//     li.dataset.filterSubCategory =
//       product.subcategories.join(',');

//     li.dataset.allCollections =
//       product.collections
//         .map(collection =>
//           collection.title
//         )
//         .join(', ');

//     const placeholderSVG =
//       window.placeholderSVG || '';

//     const imageEdges =
//       product.images?.edges || [];

//     const imageUrls =
//       imageEdges
//         .map(edge =>
//           edge.node?.url || ''
//         )
//         .filter(Boolean);

//     const hasImage =
//       imageUrls.length > 0;

//     let slidesHtml = '';

//     imageUrls.forEach(
//       (image, index) => {
//         slidesHtml += `
//           <div
//             class="swiper-slide"
//             role="group"
//             aria-label="${index + 1} / ${imageUrls.length}"
//           >
//             <img
//               src="${this.#escapeAttribute(image)}"
//               alt="${this.#escapeAttribute(product.title)}"
//               loading="lazy"
//             >
//           </div>
//         `;
//       }
//     );

//     const paginationHtml =
//       imageUrls.length > 1
//         ? `<div class="swiper-pagination gallery-progress-pagination"></div>`
//         : '';

//     const productUrl =
//       `/products/${encodeURIComponent(
//         product.handle
//       )}`;

//     li.innerHTML = `
//       <product-card
//         class="col__card product-card size-style"
//         data-product-id="${this.#escapeAttribute(product.numericId)}"
//       >

//         <a
//           href="${productUrl}"
//           class="product-card__link"
//           ref="productCardLink"
//         >
//           <span class="visually-hidden">
//             ${this.#escapeHtml(product.title)}
//           </span>
//         </a>

//         <div
//           class="product-card__content layout-panel-flex layout-panel-flex--column product-grid__card spacing-style border-style gap-style"
//           style="
//             --border-width:1px;
//             --border-style:none;
//             --border-radius:0px;
//             --flex-direction:column;
//             --padding-block-start:0px;
//             --padding-block-end:0px;
//             --padding-inline-start:0px;
//             --padding-inline-end:0px;
//             --product-card-gap:5px;
//             --quick-add-display:none;
//             --quick-add-mobile-display:none;
//             --quick-add-mobile-opacity:0;
//           "
//         >

//           <div
//             ref="cardGallery"
//             class="card-gallery card-gallery-${this.#escapeAttribute(product.numericId)}__card-gallery spacing-style border-style"
//             data-product-id="${this.#escapeAttribute(product.numericId)}"
//             data-image-ratio="portrait"
//           >

//             ${
//               hasImage
//                 ? `
//                   <div class="product-gallery-wrapper">
//                     <a
//                       href="${productUrl}"
//                       class="gallery-link"
//                     >
//                       <div class="product-gallery-swiper swiper">
//                         <div class="swiper-wrapper">
//                           ${slidesHtml}
//                         </div>

//                         <span
//                           class="swiper-notification"
//                           aria-live="assertive"
//                           aria-atomic="true"
//                         ></span>
//                       </div>
//                     </a>

//                     ${paginationHtml}
//                   </div>
//                 `
//                 : `
//                   <a
//                     class="contents"
//                     ref="cardGalleryLink"
//                     href="${productUrl}"
//                     aria-label="${this.#escapeAttribute(product.title)}"
//                   >
//                     <slideshow-component
//                       ref="slideshow"
//                       initial-slide="0"
//                       infinite=""
//                       disabled="true"
//                     >
//                       <slideshow-container
//                         ref="slideshowContainer"
//                       >
//                         <slideshow-slides
//                           tabindex="-1"
//                           ref="scroller"
//                         >
//                           <slideshow-slide
//                             ref="slides[]"
//                             aria-hidden="false"
//                             class="product-media-container card-gallery__placeholder"
//                           >
//                             ${placeholderSVG}
//                           </slideshow-slide>
//                         </slideshow-slides>
//                       </slideshow-container>
//                     </slideshow-component>
//                   </a>
//                 `
//             }

//             <div class="product__badges">
//               ${
//                 product.featured.length
//                   ? `<span class="badge new_arrivals">New Arrivals</span>`
//                   : ''
//               }
//             </div>

//           </div>

//           <div
//             class="product-grid-view-zoom-out--details"
//           >
//             <h3 class="h4">
//               ${this.#escapeHtml(product.title)}
//             </h3>
//           </div>

//           <a
//             class="contents user-select-text"
//             ref="productTitleLink"
//             href="${productUrl}"
//           >
//             <div
//               class="@theme spacing-style text-block text-block--product_title rte text-block--align-left rte"
//               style="
//                 --padding-block-start:2px;
//                 --padding-block-end:0px;
//                 --padding-inline-start:6px;
//                 --padding-inline-end:6px;
//                 --width:100%;
//                 --text-align:left;
//               "
//             >
//               <p
//                 role="heading"
//                 aria-level="3"
//               >
//                 ${this.#escapeHtml(product.title)}
//               </p>
//             </div>
//           </a>

//           <product-price
//             class="collection-product--card text-block text-block--align-left text-left h6 spacing-style"
//             data-product-id="${this.#escapeAttribute(product.numericId)}"
//           >
//             <div ref="priceContainer">

//               <div class="price__regular">
//                 <span class="price">
//                   ${this.#escapeHtml(product.currency)}
//                   ${product.price.toFixed(2)}
//                 </span>
//               </div>

//               <div class="price__sale price__hidden">
//                 <span class="price-item__group">
//                   <span class="visually-hidden">
//                     Prezzo promozionale
//                   </span>

//                   <span class="price-item--sale price">
//                     ${this.#escapeHtml(product.currency)}
//                     ${product.price.toFixed(2)}
//                   </span>
//                 </span>

//                 <span class="price-item__group">
//                   <span class="visually-hidden">
//                     Prezzo di listino
//                   </span>

//                   <span class="price-item--regular compare-at-price"></span>
//                 </span>
//               </div>

//             </div>
//           </product-price>

//         </div>
//       </product-card>
//     `;

//     return li;
//   }

//   // ============================================================
//   // GRID HELPERS
//   // ============================================================

//   #findGrid() {
//     return (
//       this.querySelector(
//         '.product-grid'
//       ) ||
//       this.querySelector(
//         '[class*="product-grid"]'
//       )
//     );
//   }

//   #clearGridProducts() {
//     const grid =
//       this.#findGrid();

//     if (!grid) {
//       return;
//     }

//     grid
//       .querySelectorAll(
//         'li.product-card-custom'
//       )
//       .forEach(item =>
//         item.remove()
//       );

//     /*
//      * Also remove any old custom cards
//      * created by a previous initialization.
//      */
//     grid
//       .querySelectorAll(
//         '[data-product-id].product-card-custom'
//       )
//       .forEach(item =>
//         item.remove()
//       );
//   }

//   #clearApiGrid() {
//     this.#clearGridProducts();

//     document
//       .querySelectorAll(
//         '.infinite-scroll-end'
//       )
//       .forEach(element =>
//         element.remove()
//       );

//     document
//       .querySelectorAll(
//         '.no-results-message'
//       )
//       .forEach(element =>
//         element.remove()
//       );
//   }

//   // ============================================================
//   // COUNT
//   // ============================================================

//   #updateProductCount() {
//     let updated = false;

//     const total =
//       this.#totalFilteredCount;

//     const showing =
//       this.#apiCurrentIndex;

//     /*
//      * Desktop
//      */
//     const desktopSelectors = [
//       '.facets--horizontal .products-count-wrapper span[role="status"]',
//       '.facets-controls-wrapper .products-count-wrapper span[role="status"]',
//       '.facets--filters-title + .products-count-wrapper span',
//       '.facets-wrapper .products-count-wrapper span',
//       '.facets-block-wrapper .products-count-wrapper span',
//       '.products-count-wrapper span[role="status"]'
//     ];

//     for (
//       const selector of desktopSelectors
//     ) {
//       const element =
//         document.querySelector(
//           selector
//         );

//       if (
//         element &&
//         !element.closest(
//           '.facets-toggle'
//         )
//       ) {
//         element.textContent =
//           total > 0
//             ? `${showing} of ${total} products`
//             : '0 products';

//         updated = true;

//         break;
//       }
//     }

//     /*
//      * Mobile
//      */
//     const mobileSelectors = [
//       '.facets-toggle .products-count-wrapper span[role="status"]',
//       '.facets-toggle .products-count-wrapper span',
//       '.facets-toggle__wrapper .products-count-wrapper span',
//       '.facets-mobile-wrapper .products-count-wrapper span'
//     ];

//     for (
//       const selector of mobileSelectors
//     ) {
//       const element =
//         document.querySelector(
//           selector
//         );

//       if (element) {
//         element.textContent =
//           total > 0
//             ? `${showing} of ${total} products`
//             : '0 products';

//         updated = true;

//         break;
//       }
//     }

//     /*
//      * Apply button
//      */
//     const applySelectors = [
//       '.facets__see-results',
//       '.facets-drawer__actions .facets__see-results',
//       '.facets__drawer-actions .facets__see-results',
//       '.facets-toggle .facets__see-results',
//       '#filters-drawer .facets__see-results'
//     ];

//     for (
//       const selector of applySelectors
//     ) {
//       const button =
//         document.querySelector(
//           selector
//         );

//       if (!button) {
//         continue;
//       }

//       const resultSpan =
//         button.querySelector(
//           '.result_products_count'
//         );

//       if (resultSpan) {
//         resultSpan.textContent =
//           `(${total} Products)`;
//       } else {
//         button.textContent =
//           `Apply (${total} Products)`;
//       }

//       updated = true;

//       break;
//     }

//     /*
//      * Filter bubble
//      */
//     const bubbleSelectors = [
//       '.filter-count-bubble__text',
//       '.facets-toggle__button .filter-count-bubble__text',
//       '.facets-mobile__title-wrapper .filter-count-bubble__text'
//     ];

//     for (
//       const selector of bubbleSelectors
//     ) {
//       const bubble =
//         document.querySelector(
//           selector
//         );

//       if (!bubble) {
//         continue;
//       }

//       bubble.textContent =
//         `(${total})`;

//       const parent =
//         bubble.closest(
//           '.filter-count-bubble'
//         );

//       if (parent) {
//         parent.style.display =
//           total > 0
//             ? 'grid'
//             : 'none';
//       }

//       updated = true;

//       break;
//     }

//     /*
//      * Drawer bubble
//      */
//     const drawerSelectors = [
//       '#filters-drawer-heading .facets__bubble',
//       '#filters-drawer-heading .bubble',
//       '.facets-drawer__title .facets__bubble',
//       '.facets-drawer__title .bubble'
//     ];

//     for (
//       const selector of drawerSelectors
//     ) {
//       const bubble =
//         document.querySelector(
//           selector
//         );

//       if (!bubble) {
//         continue;
//       }

//       bubble.textContent =
//         String(total);

//       bubble.style.display =
//         total > 0
//           ? 'inline-flex'
//           : 'none';

//       updated = true;

//       break;
//     }

//     /*
//      * Tell other custom filters that
//      * the result count changed.
//      */
//     this.dispatchEvent(
//       new CustomEvent(
//         'product-count-updated',
//         {
//           bubbles: true,

//           detail: {
//             total,
//             showing
//           }
//         }
//       )
//     );

//     return updated;
//   }

//   // ============================================================
//   // NO RESULTS
//   // ============================================================

//   #showNoResults() {
//     const grid =
//       this.#findGrid();

//     if (!grid) {
//       return;
//     }

//     this.#cleanupSentinel();

//     this.#clearGridProducts();

//     const message =
//       document.createElement(
//         'div'
//       );

//     message.className =
//       'no-results-message';

//     message.style.cssText = `
//       text-align:center;
//       padding:60px 20px;
//       font-family:Markelius Sans,sans-serif;
//       font-size:18px;
//       color:#666;
//       grid-column:1/-1;
//       width:100%;
//     `;

//     message.innerHTML = `
//       <p>
//         No products match your filters.
//       </p>
//     `;

//     grid.appendChild(
//       message
//     );

//     this.#apiCurrentIndex = 0;

//     this.#totalFilteredCount = 0;
//   }

//   // ============================================================
//   // END MESSAGE
//   // ============================================================

//   #showEndMessage() {
//     if (
//       this.#filteredProducts.length === 0
//     ) {
//       return;
//     }

//     if (
//       document.querySelector(
//         '.infinite-scroll-end'
//       )
//     ) {
//       return;
//     }

//     const grid =
//       this.#findGrid();

//     if (
//       !grid ||
//       !grid.parentElement
//     ) {
//       return;
//     }

//     const end =
//       document.createElement(
//         'div'
//       );

//     end.className =
//       'infinite-scroll-end';

//     end.style.cssText = `
//       text-align:center;
//       padding:30px 20px;
//       font-family:Markelius Sans,sans-serif;
//       font-size:14px;
//       color:#999;
//       clear:both;
//     `;

//     end.innerHTML = `
//       <p>
//         ✨ You've reached the end of matching products ✨
//       </p>
//     `;

//     grid.parentElement.appendChild(
//       end
//     );
//   }

//   // ============================================================
//   // ERROR
//   // ============================================================

//   #showErrorMessage(message) {
//     this.#hideLoading();

//     this.#cleanupSentinel();

//     const grid =
//       this.#findGrid();

//     if (!grid) {
//       return;
//     }

//     this.#clearGridProducts();

//     const error =
//       document.createElement(
//         'div'
//       );

//     error.className =
//       'product-results-error';

//     error.style.cssText = `
//       text-align:center;
//       padding:40px 20px;
//       font-family:Markelius Sans,sans-serif;
//       grid-column:1/-1;
//       width:100%;
//     `;

//     const safeMessage =
//       this.#escapeHtml(
//         message || 'Unknown error'
//       );

//     error.innerHTML = `
//       <p>
//         ⚠️ ${safeMessage}
//       </p>

//       <button
//         type="button"
//         style="
//           margin-top:10px;
//           padding:8px 20px;
//           background:#000;
//           color:#fff;
//           border:none;
//           cursor:pointer;
//           font-family:Markelius Sans;
//         "
//       >
//         Retry
//       </button>
//     `;

//     error
//       .querySelector('button')
//       ?.addEventListener(
//         'click',
//         () => {
//           this.#resetAndInitialize();
//         }
//       );

//     grid.appendChild(
//       error
//     );
//   }

//   // ============================================================
//   // LOADING
//   // ============================================================

//   #createLoadingIndicator() {
//     if (
//       this.#loadingIndicator
//     ) {
//       return;
//     }

//     this.#loadingIndicator =
//       document.createElement(
//         'div'
//       );

//     this.#loadingIndicator.className =
//       'infinite-scroll-loading';

//     this.#loadingIndicator.style.cssText = `
//       display:none;
//       text-align:center;
//       padding:30px 20px;
//       width:100%;
//       clear:both;
//     `;

//     this.#loadingIndicator.innerHTML = `
//       <div
//         style="
//           display:inline-block;
//           width:40px;
//           height:40px;
//           border:3px solid #f3f3f3;
//           border-top:3px solid #000;
//           border-radius:50%;
//           animation:casafikaResultsSpin .8s linear infinite;
//         "
//       ></div>

//       <p
//         style="
//           margin-top:10px;
//           font-family:Markelius Sans,sans-serif;
//         "
//       >
//         Loading products...
//       </p>

//       <style>
//         @keyframes casafikaResultsSpin {
//           0% {
//             transform:rotate(0deg);
//           }

//           100% {
//             transform:rotate(360deg);
//           }
//         }
//       </style>
//     `;

//     this.appendChild(
//       this.#loadingIndicator
//     );
//   }

//   #showLoading() {
//     if (
//       this.#loadingIndicator
//     ) {
//       this.#loadingIndicator.style.display =
//         'block';
//     }
//   }

//   #hideLoading() {
//     if (
//       this.#loadingIndicator
//     ) {
//       this.#loadingIndicator.style.display =
//         'none';
//     }
//   }

//   // ============================================================
//   // SENTINEL CLEANUP
//   // ============================================================

//   #cleanupSentinel() {
//     if (this.#observer) {
//       this.#observer.disconnect();
//       this.#observer = null;
//     }

//     if (
//       this.#sentinel &&
//       this.#sentinel.parentNode
//     ) {
//       this.#sentinel.remove();
//     }

//     this.#sentinel = null;
//   }

//   // ============================================================
//   // NORMAL SHOPIFY MODE
//   //
//   // Used when measurement filters are NOT active.
//   // ============================================================

//   #initInfiniteScroll() {
//     console.log(
//       '🔄 Initializing normal Horizon infinite scroll'
//     );

//     const enabled =
//       this.getAttribute(
//         'infinite-scroll'
//       ) === 'true';

//     if (!enabled) {
//       console.log(
//         'Infinite scroll disabled'
//       );

//       return;
//     }

//     setTimeout(() => {
//       this.#updatePaginationInfo();

//       if (!this.#hasNextPage) {
//         return;
//       }

//       this.#setupNormalInfiniteScroll();
//     }, 500);
//   }

//   #setupNormalInfiniteScroll() {
//     const grid =
//       this.#findGrid();

//     if (!grid) {
//       console.error(
//         '❌ Grid not found'
//       );

//       return;
//     }

//     this.#cleanupSentinel();

//     const sentinel =
//       document.createElement(
//         'div'
//       );

//     sentinel.className =
//       'infinite-scroll-sentinel';

//     sentinel.style.cssText = `
//       height:20px;
//       width:100%;
//       opacity:0;
//       pointer-events:none;
//     `;

//     sentinel.dataset.testid =
//       'normal-infinite-scroll-sentinel';

//     const parent =
//       grid.parentElement ||
//       this;

//     if (grid.nextSibling) {
//       parent.insertBefore(
//         sentinel,
//         grid.nextSibling
//       );
//     } else {
//       parent.appendChild(
//         sentinel
//       );
//     }

//     this.#sentinel =
//       sentinel;

//     this.#setupNormalObserver();
//   }

//   #setupNormalObserver() {
//     if (!this.#sentinel) {
//       return;
//     }

//     if (this.#observer) {
//       this.#observer.disconnect();
//     }

//     this.#observer =
//       new IntersectionObserver(
//         entries => {
//           if (
//             entries.some(
//               entry =>
//                 entry.isIntersecting
//             ) &&
//             !this.#isLoading &&
//             this.#hasNextPage
//           ) {
//             this.#loadNextPage();
//           }
//         },
//         {
//           rootMargin:
//             '0px 0px 300px 0px',

//           threshold:0.01
//         }
//       );

//     this.#observer.observe(
//       this.#sentinel
//     );
//   }

//   #updatePaginationInfo() {
//     const info =
//       this.querySelector(
//         '[data-pagination-info]'
//       );

//     if (info) {
//       this.#currentPage =
//         parseInt(
//           info.dataset.currentPage ||
//           '1'
//         );

//       this.#hasNextPage =
//         info.dataset.hasNextPage ===
//         'true';

//       this.#totalPages =
//         parseInt(
//           info.dataset.totalPages ||
//           '1'
//         );

//       return;
//     }

//     const params =
//       new URLSearchParams(
//         window.location.search
//       );

//     this.#currentPage =
//       parseInt(
//         params.get('page') ||
//         '1'
//       );

//     this.#hasNextPage =
//       true;

//     this.#totalPages =
//       999;
//   }

//   async #loadNextPage() {
//     if (this.#isLoading) {
//       return;
//     }

//     if (!this.#hasNextPage) {
//       this.#cleanupSentinel();

//       return;
//     }

//     this.#isLoading = true;

//     this.setAttribute(
//       'aria-busy',
//       'true'
//     );

//     // this.#showLoading();

//     const nextPage =
//       this.#currentPage + 1;

//     try {
//       const sectionId =
//         this.closest(
//           '[data-section-id]'
//         )?.getAttribute(
//           'data-section-id'
//         ) ||
//         this.getAttribute(
//           'section-id'
//         ) ||
//         'main';

//       const url =
//         new URL(
//           window.location.href
//         );

//       url.searchParams.set(
//         'page',
//         nextPage
//       );

//       url.searchParams.set(
//         'section_id',
//         sectionId
//       );

//       const response =
//         await fetch(
//           url.href
//         );

//       if (!response.ok) {
//         throw new Error(
//           `HTTP ${response.status}`
//         );
//       }

//       const html =
//         await response.text();

//       const parser =
//         new DOMParser();

//       const doc =
//         parser.parseFromString(
//           html,
//           'text/html'
//         );

//       const newResultsList =
//         doc.querySelector(
//           'results-list'
//         );

//       if (!newResultsList) {
//         throw new Error(
//           'Results list not found'
//         );
//       }

//       const currentGrid =
//         this.#findGrid();

//       const newGrid =
//         newResultsList.querySelector(
//           '.product-grid'
//         ) ||
//         newResultsList.querySelector(
//           '[class*="product-grid"]'
//         );

//       if (
//         !currentGrid ||
//         !newGrid
//       ) 
//       {
//         // throw new Error(
//         //   'Product grid not found'
//         // );
//         return;
//       }

//       let items =
//         Array.from(
//           newGrid.querySelectorAll(
//             'li'
//           )
//         );

//       if (!items.length) {
//         items =
//           Array.from(
//             newGrid.querySelectorAll(
//               '[class*="product-grid__item"]'
//             )
//           );
//       }

//       if (!items.length) {
//         this.#hasNextPage =
//           false;

//         this.#cleanupSentinel();

//         return;
//       }

//       const existingIds =
//         new Set();

//       currentGrid
//         .querySelectorAll(
//           '[data-product-id]'
//         )
//         .forEach(card => {
//           const id =
//             card.dataset.productId;

//           if (id) {
//             existingIds.add(id);
//           }
//         });

//       items.forEach(item => {
//         const id =
//           item.dataset.productId;

//         if (
//           id &&
//           existingIds.has(id)
//         ) {
//           return;
//         }

//         if (id) {
//           existingIds.add(id); 
//         }

//         item.dataset.page =
//           String(nextPage);

//         currentGrid.appendChild(
//           item
//         );
//         // // Apply measurement and price filters on top of category filters
//         //   if (window.applyFilters) {
//         //     setTimeout(() => {
//         //       window.applyFilters();
//         //     }, 50);
//         //   }
//       });
       

//       this.#currentPage =
//         nextPage;

//       const newPaginationInfo =
//         newResultsList.querySelector(
//           '[data-pagination-info]'
//         );

//       if (
//         newPaginationInfo
//       ) {
//         this.#hasNextPage =
//           newPaginationInfo.dataset.hasNextPage ===
//           'true';

//         this.#totalPages =
//           parseInt(
//             newPaginationInfo.dataset.totalPages ||
//             '1'
//           );
//       } else {
//         this.#hasNextPage =
//           items.length >=
//           0;
//       }

//       if (this.#hasNextPage) {
//         this.#setupNormalInfiniteScroll();
//       } else {
//         this.#cleanupSentinel();
//       }

//     } catch (error) {
//       console.error(
//         '❌ Normal infinite scroll error:',
//         error
//       );

//       this.#showErrorMessage(
//         error.message
//       );

//     } finally {
//       this.#isLoading = false;

//       this.removeAttribute(
//         'aria-busy'
//       );

//       this.#hideLoading();
//     }
//   }

//   // ============================================================
//   // UI
//   // ============================================================

//   #showCustomFilterButtons(
//     filters
//   ) {
//     document
//       .querySelectorAll(
//         '#clearCustomFilters'
//       )
//       .forEach(element => {
//         element.style.display =
//           filters.hasMeasurementFilters
//             ? 'flex'
//             : 'none';
//       });

//     document
//       .querySelectorAll(
//         '.price_range_clear_btn'
//       )
//       .forEach(element => {
//         element.style.display =
//           filters.priceMin ||
//           filters.priceMax
//             ? 'flex'
//             : 'none';
//       });
//   }

//   #hideCustomFilterButtons() {
//     document
//       .querySelectorAll(
//         '#clearCustomFilters'
//       )
//       .forEach(element => {
//         element.style.display =
//           'none';
//       });
//   }

//   // ============================================================
//   // HTML HELPERS
//   // ============================================================

//   #escapeHtml(value) {
//     if (
//       value === null ||
//       value === undefined
//     ) {
//       return '';
//     }

//     const div =
//       document.createElement(
//         'div'
//       );

//     div.textContent =
//       String(value);

//     return div.innerHTML;
//   }

//   #escapeAttribute(value) {
//     return this.#escapeHtml(
//       value
//     )
//       .replace(
//         /"/g,
//         '&quot;'
//       )
//       .replace(
//         /'/g,
//         '&#039;'
//       );
//   }

//   #escapeGraphQL(value) {
//     return String(value || '')
//       .replace(
//         /\\/g,
//         '\\\\'
//       )
//       .replace(
//         /"/g,
//         '\\"'
//       )
//       .replace(
//         /\n/g,
//         '\\n'
//       );
//   }

//   // ============================================================
//   // LAYOUT
//   // ============================================================

//   updateLayout({ target }) {
//     if (
//       !(target instanceof HTMLInputElement)
//     ) {
//       return;
//     }

//     this.#animateLayoutChange(
//       target.value
//     );
//   }

//   #animateLayoutChange = async (
//     value
//   ) => {
//     const { grid } =
//       this.refs;

//     if (!grid) {
//       return;
//     }

//     await startViewTransition(
//       () =>
//         this.#setLayout(
//           value
//         ),
//       ['product-grid']
//     );

//     requestIdleCallback(() => {
//       const viewport =
//         mediaQueryLarge.matches
//           ? 'desktop'
//           : 'mobile';

//       sessionStorage.setItem(
//         `product-grid-view-${viewport}`,
//         value
//       );
//     });
//   };

//   #setLayout(value) {
//     const { grid } =
//       this.refs;

//     if (!grid) {
//       return;
//     }

//     grid.setAttribute(
//       'product-grid-view',
//       value
//     );
//   }

//   #handleMediaQueryChange = (
//     event
//   ) => {
//     const targetElement =
//       event.matches
//         ? this.querySelector(
//             '[data-grid-layout="desktop-default-option"]'
//           )
//         : this.querySelector(
//             '[data-grid-layout="mobile-option"]'
//           );

//     if (
//       !(targetElement instanceof HTMLInputElement)
//     ) {
//       return;
//     }

//     targetElement.checked =
//       true;

//     this.#setLayout(
//       'default'
//     );
//   };
// }

// // ============================================================
// // CUSTOM ELEMENT
// // ============================================================

// if (
//   !customElements.get(
//     'results-list'
//   )
// ) {
//   customElements.define(
//     'results-list',
//     ResultsList
//   );
// }


import {
  mediaQueryLarge,
  requestIdleCallback,
  startViewTransition
} from '@theme/utilities';

import PaginatedList from '@theme/paginated-list';

export default class ResultsList extends PaginatedList {
  #observer = null;
  #isLoading = false;
  #hasNextPage = true;
  #sentinel = null;
  #totalPages = 1;
  #currentPage = 1;
  #loadingIndicator = null;

  // API MODE
  #isApiMode = false;
  #allProducts = [];
  #filteredProducts = [];
  #apiCurrentIndex = 0;
  #productsPerPage = 24;
  #apiLoading = false;
  #apiInitialized = false;
  #totalFilteredCount = 0;
  #mutationObserver = null;
  #filterRequestId = 0;

  #storefrontToken = '4ad8b04521da1ae814c71dfe5acc0a50';
  #storeDomain = '0e03ht-p0.myshopify.com';

  // LIFECYCLE

  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);

    this.setAttribute('initialized', '');

    this.#createLoadingIndicator();
    this.#setupMutationObserver();

    window.addEventListener('popstate', this.#handleUrlChange);
    document.addEventListener('filter-update', this.#handleFilterUpdate);
    document.addEventListener('shopify:section:load', this.#handleSectionLoad);

    requestAnimationFrame(() => {
      setTimeout(() => {
        this.#checkFiltersAndInit();
      }, 100);
    });
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
    window.removeEventListener('popstate', this.#handleUrlChange);
    document.removeEventListener('filter-update', this.#handleFilterUpdate);
    document.removeEventListener('shopify:section:load', this.#handleSectionLoad);

    this.#cleanupSentinel();

    if (this.#mutationObserver) {
      this.#mutationObserver.disconnect();
      this.#mutationObserver = null;
    }

    if (this.#loadingIndicator && this.#loadingIndicator.parentNode) {
      this.#loadingIndicator.remove();
    }
  }

  // PUBLIC

  reInitFilters() {
    console.log('🔄 ResultsList: reInitFilters');
    this.#resetAndInitialize();

    if (window.customCategoryFilters?.reInit) {
      setTimeout(() => {
        window.customCategoryFilters.reInit();
      }, 100);
    }
  }

  updateProductCount() {
    return this.#updateProductCount();
  }

  // URL / FILTER EVENTS

  #handleUrlChange = () => {
    console.log('🔄 URL changed');
    clearTimeout(this.#urlChangeTimer);
    this.#urlChangeTimer = setTimeout(() => {
      this.#resetAndInitialize();
    }, 100);
  };

  #urlChangeTimer = null;

  #handleFilterUpdate = () => {
    console.log('🔄 Filter update event');
    clearTimeout(this.#filterUpdateTimer);
    this.#filterUpdateTimer = setTimeout(() => {
      this.#resetAndInitialize();
    }, 150);
  };

  #filterUpdateTimer = null;

  #handleSectionLoad = () => {
    console.log('🔄 Shopify section loaded');
    setTimeout(() => {
      this.#resetAndInitialize();
      if (window.customCategoryFilters?.reInit) {
        window.customCategoryFilters.reInit();
      }
    }, 300);
  };

  // INITIALIZATION

  #checkFiltersAndInit() {
    const filters = this.#getFilterState();

    console.log('========================================');
    console.log('🔍 RESULTS LIST INITIALIZATION');
    console.log('Collection:', this.#getCurrentCollectionHandle());
    console.log('Filter state:', filters);
    console.log('========================================');

    if (filters.hasMeasurementFilters) {
      console.log('🔧 Measurement filter detected → API MODE');
      this.#isApiMode = true;
      this.#setupApiMode();
      return;
    }

    console.log('📄 No measurement filter → NORMAL MODE');
    this.#isApiMode = false;
    window.customFilterUsed = false;
    this.#hideCustomFilterButtons();
    this.#initInfiniteScroll();
  }

  #resetAndInitialize() {
    console.log('♻️ Resetting ResultsList');

    this.#filterRequestId++;
    this.#apiLoading = false;
    this.#apiInitialized = false;
    this.#allProducts = [];
    this.#filteredProducts = [];
    this.#apiCurrentIndex = 0;
    this.#totalFilteredCount = 0;

    this.#cleanupSentinel();
    this.#checkFiltersAndInit();
  }

  #setupMutationObserver() {
    const grid = this.#findGrid();

    if (!grid) {
      setTimeout(() => this.#setupMutationObserver(), 500);
      return;
    }

    if (this.#mutationObserver) {
      this.#mutationObserver.disconnect();
    }

    this.#mutationObserver = new MutationObserver(() => {});
    this.#mutationObserver.observe(grid, { childList: true, subtree: true });
  }

  // FILTER STATE

  #getFilterState() {
    const params = new URLSearchParams(window.location.search);

    const getValues = (key) =>
      params.getAll(key).map(v => v.trim()).filter(Boolean);

    const widthMin = params.get('filter.p.width_min');
    const widthMax = params.get('filter.p.width_max');
    const heightMin = params.get('filter.p.height_min');
    const heightMax = params.get('filter.p.height_max');
    const depthMin = params.get('filter.p.depth_min');
    const depthMax = params.get('filter.p.depth_max');

    const hasMeasurementFilters =
      !!widthMin || !!widthMax ||
      !!heightMin || !!heightMax ||
      !!depthMin || !!depthMax;

    const categories = getValues('filter.p.categorie');
    const subcategories = getValues('filter.p.subcategorie');

    return {
      params,
      widthMin, widthMax,
      heightMin, heightMax,
      depthMin, depthMax,
      hasMeasurementFilters,
      priceMin: params.get('filter.v.price.gte'),
      priceMax: params.get('filter.v.price.lte'),
      availability: getValues('filter.v.availability'),
      vendors: getValues('filter.p.vendor'),
      productTypes: getValues('filter.p.product_type'),
      categories,
      subcategories,
      designers: getValues('filter.p.m.custom.designer'),
      materials: getValues('filter.p.m.custom.metarials'),
      featured: getValues('filter.p.m.custom.featured')
    };
  }

  #getAllFilters() {
    const params = new URLSearchParams(window.location.search);
    const filters = {};

    for (const [key, value] of params.entries()) {
      if (!key.startsWith('filter.')) continue;
      if (!filters[key]) filters[key] = [];
      filters[key].push(value);
    }

    return filters;
  }

  // COLLECTION

  #getCurrentCollectionHandle() {
    const collectionElement = document.querySelector('[data-collection-handle]');
    if (collectionElement?.dataset?.collectionHandle) {
      return collectionElement.dataset.collectionHandle;
    }

    const attributeHandle = this.getAttribute('collection-handle');
    if (attributeHandle) return attributeHandle;

    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const collectionIndex = pathParts.indexOf('collections');

    if (collectionIndex !== -1 && pathParts[collectionIndex + 1]) {
      return pathParts[collectionIndex + 1];
    }

    return 'all';
  }

  // API MODE

  #setupApiMode() {
    const filters = this.#getFilterState();

    window.customFilterUsed = filters.hasMeasurementFilters;
    window.priceFilterUsed = !!filters.priceMin || !!filters.priceMax;

    this.#showCustomFilterButtons(filters);

    const pagination = document.querySelector('.pagination, [data-pagination-wrapper]');
    if (pagination) pagination.style.display = 'none';

    this.#cleanupSentinel();
    this.#clearApiGrid();

    this.#allProducts = [];
    this.#filteredProducts = [];
    this.#apiCurrentIndex = 0;
    this.#totalFilteredCount = 0;

    this.#fetchAllProductsWithCursor();
  }

  // FETCH ALL PRODUCTS

  async #fetchAllProductsWithCursor() {
    if (this.#apiLoading) return;

    this.#apiLoading = true;

    const requestId = ++this.#filterRequestId;

    this.#showLoading();

    try {
      const collectionHandle = this.#getCurrentCollectionHandle();

      console.log('📁 Fetching collection:', collectionHandle);

      let cursor = null;
      let hasNextPage = true;
      let page = 0;

      while (hasNextPage) {
        page++;

        if (requestId !== this.#filterRequestId) {
          console.log('🛑 Old API request cancelled');
          return;
        }

        console.log(`📥 API page ${page}`);

        const query = this.#buildProductsQuery(collectionHandle, cursor);

        const response = await fetch(
          `https://${this.#storeDomain}/api/2024-04/graphql.json`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': this.#storefrontToken
            },
            body: JSON.stringify({ query })
          }
        );

        if (!response.ok) {
          throw new Error(`Shopify API HTTP ${response.status}`);
        }

        const result = await response.json();

        if (result.errors?.length) {
          console.error('Shopify GraphQL errors:', result.errors);
          throw new Error(result.errors[0]?.message || 'Shopify API error');
        }

        const connection =
          collectionHandle
            ? result.data?.collection?.products
            : result.data?.products;

        if (!connection) {
          throw new Error('No product connection returned by Shopify');
        }

        const edges = connection.edges || [];
        const normalized = edges.map(edge => this.#normalizeProduct(edge.node));

        this.#allProducts.push(...normalized);

        console.log(`📦 Received ${edges.length} products`);
        console.log(`📊 Total fetched: ${this.#allProducts.length}`);

        hasNextPage = !!connection.pageInfo?.hasNextPage;
        cursor = connection.pageInfo?.endCursor || null;

        if (page === 1) {
          this.#hideLoading();
          this.#applyAllFilters();
        } else {
          this.#appendFilteredBatch(normalized);
        }

        if (!cursor && hasNextPage) {
          console.warn('⚠️ Shopify returned hasNextPage without cursor');
          break;
        }
      }

      if (requestId !== this.#filterRequestId) return;

      console.log(`✅ Finished fetching ${this.#allProducts.length} products`);

      this.#apiInitialized = true;

    } catch (error) {
      console.error('❌ API error:', error);
      this.#showErrorMessage(error.message);
    } finally {
      this.#apiLoading = false;
      this.#hideLoading();
    }
  }

  // GRAPHQL QUERY

  #buildProductsQuery(collectionHandle, cursor) {
    const filters = this.#buildShopifyFilters();

    const after = cursor ? `, after: "${cursor}"` : '';
    const filterArgument = filters.length
      ? `, filters: { ${filters.join(', ')} }`
      : '';

    const productFields = `
      id
      title
      handle
      description
      vendor
      productType
      availableForSale

      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
      }

      widthValue: metafield(namespace: "custom", key: "measurement_width") {
        value
      }

      heightValue: metafield(namespace: "custom", key: "measurement_height") {
        value
      }

      depthValue: metafield(namespace: "custom", key: "measurement_depth") {
        value
      }

      categories: metafield(namespace: "custom", key: "categories") {
        value
      }

      subcategories: metafield(namespace: "custom", key: "subcategories") {
        value
      }

      designer: metafield(namespace: "custom", key: "designer") {
        value
      }

      materials: metafield(namespace: "custom", key: "metarials") {
        value
      }

      featured: metafield(namespace: "custom", key: "featured") {
        value
      }

      images(first: 4) {
        edges {
          node {
            url
            altText
          }
        }
      }

      collections(first: 100) {
        edges {
          node {
            title
            handle
          }
        }
      }
    `;

    if (collectionHandle) {
      return `
        {
          collection(handle: "${this.#escapeGraphQL(collectionHandle)}") {
            products(first: 250 ${after} ${filterArgument}) {
              edges {
                node {
                  ${productFields}
                }
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
          }
        }
      `;
    }

    return `
      {
        products(first: 250 ${after} ${filterArgument}) {
          edges {
            node {
              ${productFields}
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `;
  }

  // SHOPIFY SERVER FILTERS

  #buildShopifyFilters() {
    const filters = this.#getFilterState();
    const parts = [];

    if (filters.priceMin || filters.priceMax) {
      const min = filters.priceMin ? parseFloat(filters.priceMin) : null;
      const max = filters.priceMax ? parseFloat(filters.priceMax) : null;

      if (min !== null && max !== null) {
        parts.push(`price: { min: ${min}, max: ${max} }`);
      } else if (min !== null) {
        parts.push(`price: { min: ${min} }`);
      } else if (max !== null) {
        parts.push(`price: { max: ${max} }`);
      }
    }

    if (filters.availability.length) {
      const available =
        filters.availability.includes('1') ||
        filters.availability.includes('true');
      parts.push(`available: ${available}`);
    }

    if (filters.vendors.length === 1) {
      parts.push(`vendor: "${this.#escapeGraphQL(filters.vendors[0])}"`);
    }

    if (filters.productTypes.length === 1) {
      parts.push(`productType: "${this.#escapeGraphQL(filters.productTypes[0])}"`);
    }

    const params = new URLSearchParams(window.location.search);
    const optionGroups = {};

    for (const [key, value] of params.entries()) {
      if (!key.startsWith('filter.v.option.')) continue;
      const optionName = key.replace('filter.v.option.', '');
      if (!optionGroups[optionName]) optionGroups[optionName] = [];
      optionGroups[optionName].push(value);
    }

    Object.entries(optionGroups).forEach(([optionName, values]) => {
      if (values.length === 1) {
        parts.push(
          `variantOption: { name: "${this.#escapeGraphQL(optionName)}", value: "${this.#escapeGraphQL(values[0])}" }`
        );
      }
    });

    return parts;
  }

  // NORMALIZE PRODUCT

  #normalizeProduct(node) {
    return {
      id: node.id,
      numericId: node.id?.split('/').pop() || '',
      title: node.title || '',
      handle: node.handle || '',
      description: node.description || '',
      vendor: node.vendor || '',
      productType: node.productType || '',
      availableForSale: !!node.availableForSale,
      price: parseFloat(node.priceRange?.minVariantPrice?.amount || 0),
      currency: node.priceRange?.minVariantPrice?.currencyCode || 'EUR',
      width: node.widthValue?.value || '',
      height: node.heightValue?.value || '',
      depth: node.depthValue?.value || '',
      categories: this.#parseMetafield(node.categories?.value),
      subcategories: this.#parseMetafield(node.subcategories?.value),
      designer: this.#parseMetafield(node.designer?.value),
      materials: this.#parseMetafield(node.materials?.value),
      featured: this.#parseMetafield(node.featured?.value),
      images: node.images || { edges: [] },
      collections: (node.collections?.edges || []).map(edge => ({
        title: edge.node?.title || '',
        handle: edge.node?.handle || ''
      }))
    };
  }

  #parseMetafield(value) {
    if (value === null || value === undefined || value === '') return [];

    if (Array.isArray(value)) {
      return value.map(String).map(v => v.trim()).filter(Boolean);
    }

    const stringValue = String(value).trim();

    if (stringValue.startsWith('[') && stringValue.endsWith(']')) {
      try {
        const parsed = JSON.parse(stringValue);
        if (Array.isArray(parsed)) {
          return parsed.map(String).map(v => v.trim()).filter(Boolean);
        }
      } catch (error) {}
    }

    if (stringValue.includes(',')) {
      return stringValue.split(',').map(v => v.trim()).filter(Boolean);
    }

    return [stringValue];
  }

  /*
   * Collect every string a product can be matched against for a
   * given filter value. Combines:
   *   - the product's Shopify collection titles
   *   - the product's custom metafield categories/subcategories
   *
   * Both sources are combined so that whichever one your theme
   * happens to use for a given product, the filter still finds
   * it. This is what makes the API-mode filter agree with the
   * client-side checkbox filter, which only ever sees the
   * collection titles (data-all-collections).
   */
  #categoryHaystack(product) {
    const fromCollections = (product.collections || []).map(c => c.title);
    const fromMetafield = product.categories || [];
    return [...fromCollections, ...fromMetafield];
  }

  #subcategoryHaystack(product) {
    const fromCollections = (product.collections || []).map(c => c.title);
    const fromMetafield = product.subcategories || [];
    return [...fromCollections, ...fromMetafield];
  }

  // APPLY ALL FILTERS (FIRST PAGE)

  #applyAllFilters() {
    const filters = this.#getFilterState();
    let products = [...this.#allProducts];

    console.log('========================================');
    console.log('🔎 APPLYING FILTERS');
    console.log('Products before:', products.length);

    if (filters.widthMin || filters.widthMax) {
      const min = filters.widthMin ? this.#toNumber(filters.widthMin, 0) : 0;
      const max = filters.widthMax ? this.#toNumber(filters.widthMax, Infinity) : Infinity;

      products = products.filter(product => {
        const value = this.#toNumber(product.width, NaN);
        if (!Number.isFinite(value) || value <= 0) return false;
        return value >= min && value <= max;
      });

      console.log('After width:', products.length);
    }

    if (filters.heightMin || filters.heightMax) {
      const min = filters.heightMin ? this.#toNumber(filters.heightMin, 0) : 0;
      const max = filters.heightMax ? this.#toNumber(filters.heightMax, Infinity) : Infinity;

      products = products.filter(product => {
        const value = this.#toNumber(product.height, NaN);
        if (!Number.isFinite(value) || value <= 0) return false;
        return value >= min && value <= max;
      });

      console.log('After height:', products.length);
    }

    if (filters.depthMin || filters.depthMax) {
      const min = filters.depthMin ? this.#toNumber(filters.depthMin, 0) : 0;
      const max = filters.depthMax ? this.#toNumber(filters.depthMax, Infinity) : Infinity;

      products = products.filter(product => {
        const value = this.#toNumber(product.depth, NaN);
        if (!Number.isFinite(value) || value <= 0) return false;
        return value >= min && value <= max;
      });

      console.log('After depth:', products.length);
    }

    if (filters.categories.length) {
      products = products.filter(product =>
        this.#matchesAny(
          this.#categoryHaystack(product),
          filters.categories
        )
      );
      console.log('After category:', products.length);
    }

    if (filters.subcategories.length) {
      products = products.filter(product =>
        this.#matchesAny(
          this.#subcategoryHaystack(product),
          filters.subcategories
        )
      );
      console.log('After subcategory:', products.length);
    }

    if (filters.designers.length) {
      products = products.filter(product =>
        this.#matchesAny(
          [...product.designer, ...product.collections.map(c => c.title)],
          filters.designers
        )
      );
    }

    if (filters.materials.length) {
      products = products.filter(product =>
        this.#matchesAny(product.materials, filters.materials)
      );
    }

    if (filters.featured.length) {
      products = products.filter(product =>
        this.#matchesAny(product.featured, filters.featured)
      );
    }

    if (filters.priceMin || filters.priceMax) {
      const min = this.#toNumber(filters.priceMin, 0);
      const max = this.#toNumber(filters.priceMax, Infinity);

      products = products.filter(product =>
        product.price >= min && product.price <= max
      );

      console.log('After price:', products.length);
    }

    if (filters.availability.length) {
      const wantsAvailable =
        filters.availability.includes('1') ||
        filters.availability.includes('true');

      products = products.filter(product =>
        wantsAvailable ? product.availableForSale : true
      );
    }

    const seenIds = new Set();
    products = products.filter(product => {
      const id = product.numericId;
      if (!id || seenIds.has(id)) return false;
      seenIds.add(id);
      return true;
    });

    this.#filteredProducts = products;
    this.#totalFilteredCount = products.length;

    console.log('========================================');
    console.log('✅ FINAL PRODUCTS:', this.#totalFilteredCount);
    console.log('========================================');

    this.#renderFilteredProducts();
  }

  // APPEND FILTERED BATCH (BACKGROUND PAGES)

  #appendFilteredBatch(newProducts) {
    if (!newProducts || !newProducts.length) return;

    const filters = this.#getFilterState();
    let products = [...newProducts];

    if (filters.widthMin || filters.widthMax) {
      const min = filters.widthMin ? this.#toNumber(filters.widthMin, 0) : 0;
      const max = filters.widthMax ? this.#toNumber(filters.widthMax, Infinity) : Infinity;
      products = products.filter(p => {
        const v = this.#toNumber(p.width, NaN);
        return Number.isFinite(v) && v > 0 && v >= min && v <= max;
      });
    }

    if (filters.heightMin || filters.heightMax) {
      const min = filters.heightMin ? this.#toNumber(filters.heightMin, 0) : 0;
      const max = filters.heightMax ? this.#toNumber(filters.heightMax, Infinity) : Infinity;
      products = products.filter(p => {
        const v = this.#toNumber(p.height, NaN);
        return Number.isFinite(v) && v > 0 && v >= min && v <= max;
      });
    }

    if (filters.depthMin || filters.depthMax) {
      const min = filters.depthMin ? this.#toNumber(filters.depthMin, 0) : 0;
      const max = filters.depthMax ? this.#toNumber(filters.depthMax, Infinity) : Infinity;
      products = products.filter(p => {
        const v = this.#toNumber(p.depth, NaN);
        return Number.isFinite(v) && v > 0 && v >= min && v <= max;
      });
    }

    if (filters.categories.length) {
      products = products.filter(p =>
        this.#matchesAny(this.#categoryHaystack(p), filters.categories)
      );
    }

    if (filters.subcategories.length) {
      products = products.filter(p =>
        this.#matchesAny(this.#subcategoryHaystack(p), filters.subcategories)
      );
    }

    if (filters.designers.length) {
      products = products.filter(p =>
        this.#matchesAny(
          [...p.designer, ...p.collections.map(c => c.title)],
          filters.designers
        )
      );
    }

    if (filters.materials.length) {
      products = products.filter(p => this.#matchesAny(p.materials, filters.materials));
    }

    if (filters.featured.length) {
      products = products.filter(p => this.#matchesAny(p.featured, filters.featured));
    }

    if (filters.priceMin || filters.priceMax) {
      const min = this.#toNumber(filters.priceMin, 0);
      const max = this.#toNumber(filters.priceMax, Infinity);
      products = products.filter(p => p.price >= min && p.price <= max);
    }

    if (filters.availability.length) {
      const wantsAvailable =
        filters.availability.includes('1') ||
        filters.availability.includes('true');
      products = products.filter(p => wantsAvailable ? p.availableForSale : true);
    }

    if (!products.length) return;

    const existingIds = new Set(this.#filteredProducts.map(p => p.numericId));
    products = products.filter(p => !existingIds.has(p.numericId));

    if (!products.length) return;

    this.#filteredProducts.push(...products);
    this.#totalFilteredCount = this.#filteredProducts.length;

    this.#showNextBatch();
  }

  // MATCH HELPERS

  #matchesAny(productValues, filterValues) {
    const products = (productValues || []).map(v => this.#normalizeValue(v));
    const filters = (filterValues || []).map(v => this.#normalizeValue(v));
    return filters.some(filter => products.includes(filter));
  }

  #normalizeValue(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  #toNumber(value, fallback) {
    if (value === null || value === undefined || value === '') return fallback;

    const number = parseFloat(
      String(value).replace(',', '.').replace(/[^\d.-]/g, '')
    );

    return Number.isFinite(number) ? number : fallback;
  }

  // RENDER (API MODE)

  #renderFilteredProducts() {
    const grid = this.#findGrid();
    if (!grid) {
      console.error('❌ Product grid not found');
      return;
    }

    this.#cleanupSentinel();
    this.#clearGridProducts();
    this.#apiCurrentIndex = 0;

    if (this.#filteredProducts.length === 0) {
      this.#showNoResults();
      this.#updateProductCount();
      return;
    }

    this.#showNextBatch();
    this.#updateProductCount();

    if (this.#apiCurrentIndex < this.#filteredProducts.length) {
      setTimeout(() => this.#setupApiInfiniteScroll(), 100);
    }
  }

  #showNextBatch() {
    const grid = this.#findGrid();
    if (!grid) return;

    const start = this.#apiCurrentIndex;
    const end = Math.min(start + this.#productsPerPage, this.#filteredProducts.length);
    const batch = this.#filteredProducts.slice(start, end);

    console.log(`🎨 Rendering ${start + 1}-${end} of ${this.#filteredProducts.length}`);

    const existingIds = new Set();
    grid.querySelectorAll('.product-card-custom').forEach(card => {
      const id = card.dataset.productId;
      if (id) existingIds.add(id);
    });

    let animationIndex = 0;

    batch.forEach(product => {
      const productId = product.numericId;
      if (existingIds.has(productId)) return;

      const card = this.#createProductCard(product);
      existingIds.add(productId);

      card.style.opacity = '0';
      card.style.transform = 'translateY(20px)';
      card.style.transition =
        `opacity 0.3s ease ${animationIndex * 0.05}s, ` +
        `transform 0.3s ease ${animationIndex * 0.05}s`;

      grid.appendChild(card);
      animationIndex++;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          card.style.opacity = '1';
          card.style.transform = 'translateY(0)';
        });
      });
    });

    this.#apiCurrentIndex = end;
    this.#updateProductCount();

    if (this.#apiCurrentIndex >= this.#filteredProducts.length) {
      this.#cleanupSentinel();
      this.#showEndMessage();
    }
  }

  #setupApiInfiniteScroll() {
    this.#cleanupSentinel();

    if (this.#apiCurrentIndex >= this.#filteredProducts.length) return;

    const grid = this.#findGrid();
    if (!grid || !grid.parentElement) return;

    const sentinel = document.createElement('div');
    sentinel.className = 'infinite-scroll-sentinel';
    sentinel.style.cssText = 'height:30px;width:100%;opacity:0;pointer-events:none;';
    sentinel.dataset.testid = 'api-infinite-scroll-sentinel';
    this.#sentinel = sentinel;

    grid.parentElement.appendChild(sentinel);

    this.#observer = new IntersectionObserver(
      entries => {
        const visible = entries.some(e => e.isIntersecting);
        if (!visible || this.#apiLoading) return;

        if (this.#apiCurrentIndex >= this.#filteredProducts.length) {
          this.#cleanupSentinel();
          return;
        }

        this.#showNextBatch();

        if (this.#apiCurrentIndex < this.#filteredProducts.length) {
          setTimeout(() => this.#setupApiInfiniteScroll(), 50);
        }
      },
      { rootMargin: '0px 0px 500px 0px', threshold: 0.01 }
    );

    this.#observer.observe(sentinel);
  }

  // PRODUCT CARD

  #createProductCard(product) {
    const li = document.createElement('li');

    li.className = 'product-card-custom product-grid__item product-grid__item--0';
    li.dataset.productId = product.numericId;
    li.dataset.width = product.width || '';
    li.dataset.height = product.height || '';
    li.dataset.depth = product.depth || '';
    li.dataset.priceFilter = String(product.price);
    li.dataset.currency = product.currency;
    li.dataset.page = '1';

    li.setAttribute('ref', 'cards[]');

    li.dataset.filterCategory = product.categories.join(',');
    li.dataset.filterSubCategory = product.subcategories.join(',');
    li.dataset.allCollections = product.collections.map(c => c.title).join(', ');

    const placeholderSVG = window.placeholderSVG || '';
    const imageEdges = product.images?.edges || [];
    const imageUrls = imageEdges.map(e => e.node?.url || '').filter(Boolean);
    const hasImage = imageUrls.length > 0;

    let slidesHtml = '';
    imageUrls.forEach((image, index) => {
      slidesHtml += `
        <div class="swiper-slide" role="group" aria-label="${index + 1} / ${imageUrls.length}">
          <img src="${this.#escapeAttribute(image)}" alt="${this.#escapeAttribute(product.title)}" loading="lazy">
        </div>
      `;
    });

    const paginationHtml = imageUrls.length > 1
      ? `<div class="swiper-pagination gallery-progress-pagination"></div>`
      : '';

    const productUrl = `/products/${encodeURIComponent(product.handle)}`;

    li.innerHTML = `
      <product-card class="col__card product-card size-style" data-product-id="${this.#escapeAttribute(product.numericId)}">
        <a href="${productUrl}" class="product-card__link" ref="productCardLink">
          <span class="visually-hidden">${this.#escapeHtml(product.title)}</span>
        </a>
        <div class="product-card__content layout-panel-flex layout-panel-flex--column product-grid__card spacing-style border-style gap-style" style="--border-width:1px;--border-style:none;--border-radius:0px;--flex-direction:column;--padding-block-start:0px;--padding-block-end:0px;--padding-inline-start:0px;--padding-inline-end:0px;--product-card-gap:5px;--quick-add-display:none;--quick-add-mobile-display:none;--quick-add-mobile-opacity:0;">
          <div ref="cardGallery" class="card-gallery card-gallery-${this.#escapeAttribute(product.numericId)}__card-gallery spacing-style border-style" data-product-id="${this.#escapeAttribute(product.numericId)}" data-image-ratio="portrait">
            ${
              hasImage
                ? `
                  <div class="product-gallery-wrapper">
                    <a href="${productUrl}" class="gallery-link">
                      <div class="product-gallery-swiper swiper">
                        <div class="swiper-wrapper">${slidesHtml}</div>
                        <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
                      </div>
                    </a>
                    ${paginationHtml}
                  </div>
                `
                : `
                  <a class="contents" ref="cardGalleryLink" href="${productUrl}" aria-label="${this.#escapeAttribute(product.title)}">
                    <slideshow-component ref="slideshow" initial-slide="0" infinite="" disabled="true">
                      <slideshow-container ref="slideshowContainer">
                        <slideshow-slides tabindex="-1" ref="scroller">
                          <slideshow-slide ref="slides[]" aria-hidden="false" class="product-media-container card-gallery__placeholder">
                            ${placeholderSVG}
                          </slideshow-slide>
                        </slideshow-slides>
                      </slideshow-container>
                    </slideshow-component>
                  </a>
                `
            }
            <div class="product__badges">
              ${product.featured.length ? `<span class="badge new_arrivals">New Arrivals</span>` : ''}
            </div>
          </div>
          <div class="product-grid-view-zoom-out--details">
            <h3 class="h4">${this.#escapeHtml(product.title)}</h3>
          </div>
          <a class="contents user-select-text" ref="productTitleLink" href="${productUrl}">
            <div class="@theme spacing-style text-block text-block--product_title rte text-block--align-left rte" style="--padding-block-start:2px;--padding-block-end:0px;--padding-inline-start:6px;--padding-inline-end:6px;--width:100%;--text-align:left;">
              <p role="heading" aria-level="3">${this.#escapeHtml(product.title)}</p>
            </div>
          </a>
          <product-price class="collection-product--card text-block text-block--align-left text-left h6 spacing-style" data-product-id="${this.#escapeAttribute(product.numericId)}">
            <div ref="priceContainer">
              <div class="price__regular">
                <span class="price">${this.#escapeHtml(product.currency)} ${product.price.toFixed(2)}</span>
              </div>
              <div class="price__sale price__hidden">
                <span class="price-item__group">
                  <span class="visually-hidden">Prezzo promozionale</span>
                  <span class="price-item--sale price">${this.#escapeHtml(product.currency)} ${product.price.toFixed(2)}</span>
                </span>
                <span class="price-item__group">
                  <span class="visually-hidden">Prezzo di listino</span>
                  <span class="price-item--regular compare-at-price"></span>
                </span>
              </div>
            </div>
          </product-price>
        </div>
      </product-card>
    `;

    return li;
  }

  // GRID HELPERS

  #findGrid() {
    return (
      this.querySelector('.product-grid') ||
      this.querySelector('[class*="product-grid"]')
    );
  }

  #clearGridProducts() {
    const grid = this.#findGrid();
    if (!grid) return;

    grid.querySelectorAll('li.product-card-custom').forEach(item => item.remove());
    grid.querySelectorAll('[data-product-id].product-card-custom').forEach(item => item.remove());
  }

  #clearApiGrid() {
    this.#clearGridProducts();
    document.querySelectorAll('.infinite-scroll-end').forEach(el => el.remove());
    document.querySelectorAll('.no-results-message').forEach(el => el.remove());
  }

  // COUNT

  #updateProductCount() {
    let updated = false;

    const total = this.#totalFilteredCount;
    const showing = this.#apiCurrentIndex;

    const desktopSelectors = [
      '.facets--horizontal .products-count-wrapper span[role="status"]',
      '.facets-controls-wrapper .products-count-wrapper span[role="status"]',
      '.facets--filters-title + .products-count-wrapper span',
      '.facets-wrapper .products-count-wrapper span',
      '.facets-block-wrapper .products-count-wrapper span',
      '.products-count-wrapper span[role="status"]'
    ];

    for (const selector of desktopSelectors) {
      const element = document.querySelector(selector);
      if (element && !element.closest('.facets-toggle')) {
        element.textContent =
          total > 0 ? `${showing} of ${total} products` : '0 products';
        updated = true;
        break;
      }
    }

    const mobileSelectors = [
      '.facets-toggle .products-count-wrapper span[role="status"]',
      '.facets-toggle .products-count-wrapper span',
      '.facets-toggle__wrapper .products-count-wrapper span',
      '.facets-mobile-wrapper .products-count-wrapper span'
    ];

    for (const selector of mobileSelectors) {
      const element = document.querySelector(selector);
      if (element) {
        element.textContent =
          total > 0 ? `${showing} of ${total} products` : '0 products';
        updated = true;
        break;
      }
    }

    const applySelectors = [
      '.facets__see-results',
      '.facets-drawer__actions .facets__see-results',
      '.facets__drawer-actions .facets__see-results',
      '.facets-toggle .facets__see-results',
      '#filters-drawer .facets__see-results'
    ];

    for (const selector of applySelectors) {
      const button = document.querySelector(selector);
      if (!button) continue;

      const resultSpan = button.querySelector('.result_products_count');
      if (resultSpan) {
        resultSpan.textContent = `(${total} Products)`;
      } else {
        button.textContent = `Apply (${total} Products)`;
      }
      updated = true;
      break;
    }

    const bubbleSelectors = [
      '.filter-count-bubble__text',
      '.facets-toggle__button .filter-count-bubble__text',
      '.facets-mobile__title-wrapper .filter-count-bubble__text'
    ];

    for (const selector of bubbleSelectors) {
      const bubble = document.querySelector(selector);
      if (!bubble) continue;

      bubble.textContent = `(${total})`;
      const parent = bubble.closest('.filter-count-bubble');
      if (parent) parent.style.display = total > 0 ? 'grid' : 'none';
      updated = true;
      break;
    }

    const drawerSelectors = [
      '#filters-drawer-heading .facets__bubble',
      '#filters-drawer-heading .bubble',
      '.facets-drawer__title .facets__bubble',
      '.facets-drawer__title .bubble'
    ];

    for (const selector of drawerSelectors) {
      const bubble = document.querySelector(selector);
      if (!bubble) continue;

      bubble.textContent = String(total);
      bubble.style.display = total > 0 ? 'inline-flex' : 'none';
      updated = true;
      break;
    }

    this.dispatchEvent(
      new CustomEvent('product-count-updated', {
        bubbles: true,
        detail: { total, showing }
      })
    );

    return updated;
  }

  // NO RESULTS / END / ERROR

  #showNoResults() {
    const grid = this.#findGrid();
    if (!grid) return;

    this.#cleanupSentinel();
    this.#clearGridProducts();

    const message = document.createElement('div');
    message.className = 'no-results-message';
    message.style.cssText =
      'text-align:center;padding:60px 20px;font-family:Markelius Sans,sans-serif;font-size:18px;color:#666;grid-column:1/-1;width:100%;';
    message.innerHTML = '<p>No products match your filters.</p>';

    grid.appendChild(message);

    this.#apiCurrentIndex = 0;
    this.#totalFilteredCount = 0;
  }

  #showEndMessage() {
    if (this.#filteredProducts.length === 0) return;
    if (document.querySelector('.infinite-scroll-end')) return;

    const grid = this.#findGrid();
    if (!grid || !grid.parentElement) return;

    const end = document.createElement('div');
    end.className = 'infinite-scroll-end';
    end.style.cssText =
      'text-align:center;padding:30px 20px;font-family:Markelius Sans,sans-serif;font-size:14px;color:#999;clear:both;';
    end.innerHTML = `<p>✨ You've reached the end of matching products ✨</p>`;

    grid.parentElement.appendChild(end);
  }

  #showErrorMessage(message) {
    this.#hideLoading();
    this.#cleanupSentinel();

    const grid = this.#findGrid();
    if (!grid) return;

    this.#clearGridProducts();

    const error = document.createElement('div');
    error.className = 'product-results-error';
    error.style.cssText =
      'text-align:center;padding:40px 20px;font-family:Markelius Sans,sans-serif;grid-column:1/-1;width:100%;';

    const safeMessage = this.#escapeHtml(message || 'Unknown error');

    error.innerHTML = `
      <p>⚠️ ${safeMessage}</p>
      <button type="button" style="margin-top:10px;padding:8px 20px;background:#000;color:#fff;border:none;cursor:pointer;font-family:Markelius Sans;">Retry</button>
    `;

    error.querySelector('button')?.addEventListener('click', () => {
      this.#resetAndInitialize();
    });

    grid.appendChild(error);
  }

  // LOADING

  #createLoadingIndicator() {
    if (this.#loadingIndicator) return;

    this.#loadingIndicator = document.createElement('div');
    this.#loadingIndicator.className = 'infinite-scroll-loading';
    this.#loadingIndicator.style.cssText =
      'display:none;text-align:center;padding:30px 20px;width:100%;clear:both;';

    this.#loadingIndicator.innerHTML = `
      <div style="display:inline-block;width:40px;height:40px;border:3px solid #f3f3f3;border-top:3px solid #000;border-radius:50%;animation:casafikaResultsSpin .8s linear infinite;"></div>
      <p style="margin-top:10px;font-family:Markelius Sans,sans-serif;">Loading products...</p>
      <style>@keyframes casafikaResultsSpin {0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}</style>
    `;

    this.appendChild(this.#loadingIndicator);
  }

  #showLoading() {
    if (this.#loadingIndicator) this.#loadingIndicator.style.display = 'block';
  }

  #hideLoading() {
    if (this.#loadingIndicator) this.#loadingIndicator.style.display = 'none';
  }

  // SENTINEL CLEANUP

  #cleanupSentinel() {
    if (this.#observer) {
      this.#observer.disconnect();
      this.#observer = null;
    }

    if (this.#sentinel && this.#sentinel.parentNode) {
      this.#sentinel.remove();
    }

    this.#sentinel = null;
  }

  // NORMAL SHOPIFY MODE

  #initInfiniteScroll() {
    console.log('🔄 Initializing normal Horizon infinite scroll');

    const enabled = this.getAttribute('infinite-scroll') === 'true';
    if (!enabled) {
      console.log('Infinite scroll disabled');
      return;
    }

    setTimeout(() => {
      this.#updatePaginationInfo();
      if (!this.#hasNextPage) return;
      this.#setupNormalInfiniteScroll();
    }, 500);
  }

  #setupNormalInfiniteScroll() {
    const grid = this.#findGrid();
    if (!grid) {
      console.error('❌ Grid not found');
      return;
    }

    this.#cleanupSentinel();

    const sentinel = document.createElement('div');
    sentinel.className = 'infinite-scroll-sentinel';
    sentinel.style.cssText = 'height:20px;width:100%;opacity:0;pointer-events:none;';
    sentinel.dataset.testid = 'normal-infinite-scroll-sentinel';

    const parent = grid.parentElement || this;
    if (grid.nextSibling) {
      parent.insertBefore(sentinel, grid.nextSibling);
    } else {
      parent.appendChild(sentinel);
    }

    this.#sentinel = sentinel;
    this.#setupNormalObserver();
  }

  #setupNormalObserver() {
    if (!this.#sentinel) return;

    if (this.#observer) this.#observer.disconnect();

    this.#observer = new IntersectionObserver(
      entries => {
        if (
          entries.some(e => e.isIntersecting) &&
          !this.#isLoading &&
          this.#hasNextPage
        ) {
          this.#loadNextPage();
        }
      },
      { rootMargin: '0px 0px 300px 0px', threshold: 0.01 }
    );

    this.#observer.observe(this.#sentinel);
  }

  #updatePaginationInfo() {
    const info = this.querySelector('[data-pagination-info]');

    if (info) {
      this.#currentPage = parseInt(info.dataset.currentPage || '1', 10);
      this.#hasNextPage = info.dataset.hasNextPage === 'true';
      this.#totalPages = parseInt(info.dataset.totalPages || '1', 10);
      return;
    }

    const params = new URLSearchParams(window.location.search);
    this.#currentPage = parseInt(params.get('page') || '1', 10);
    this.#hasNextPage = true;
    this.#totalPages = 999;
  }

  async #loadNextPage() {
    if (this.#isLoading) return;
    if (!this.#hasNextPage) {
      this.#cleanupSentinel();
      return;
    }

    this.#isLoading = true;
    this.setAttribute('aria-busy', 'true');

    const currentGrid = this.#findGrid();
    if (!currentGrid) {
      this.#isLoading = false;
      this.removeAttribute('aria-busy');
      return;
    }

    let maxRenderedPage = 1;
    currentGrid.querySelectorAll('.product-card-custom').forEach(card => {
      const p = parseInt(card.dataset.page || '0', 10);
      if (Number.isFinite(p) && p > maxRenderedPage) maxRenderedPage = p;
    });

    const nextPage = maxRenderedPage + 1;
    this.#currentPage = maxRenderedPage;

    try {
      const sectionId =
        this.closest('[data-section-id]')?.getAttribute('data-section-id') ||
        this.getAttribute('section-id') ||
        'main';

      const url = new URL(window.location.href);
      url.searchParams.set('page', nextPage);
      url.searchParams.set('section_id', sectionId);

      const response = await fetch(url.href);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newResultsList = doc.querySelector('results-list');
      if (!newResultsList) throw new Error('Results list not found');

      const newGrid =
        newResultsList.querySelector('.product-grid') ||
        newResultsList.querySelector('[class*="product-grid"]');

      if (!newGrid) return;

      let items = Array.from(newGrid.querySelectorAll('li'));
      if (!items.length) {
        items = Array.from(newGrid.querySelectorAll('[class*="product-grid__item"]'));
      }

      if (!items.length) {
        this.#hasNextPage = false;
        this.#cleanupSentinel();
        return;
      }

      const existingIds = new Set();
      currentGrid.querySelectorAll('[data-product-id]').forEach(card => {
        const id = card.dataset.productId;
        if (id) existingIds.add(id);
      });

      // const container = document.querySelector('.range_slide_container.active_ranges_filter');
      // const hasMeasurementFilter = !!container && window.customFilterUsed;

      // let minW = 0, maxW = Infinity;
      // let minH = 0, maxH = Infinity;
      // let minD = 0, maxD = Infinity;

      // if (hasMeasurementFilter) {
      //   minW = parseInt(container.querySelector('#myMinWidth')?.value || 1, 10);
      //   maxW = parseInt(container.querySelector('#myMaxWidth')?.value || 999999, 10);
      //   minH = parseInt(container.querySelector('#myMinHeight')?.value || 1, 10);
      //   maxH = parseInt(container.querySelector('#myMaxHeight')?.value || 999999, 10);
      //   minD = parseInt(container.querySelector('#myMinDepth')?.value || 1, 10);
      //   maxD = parseInt(container.querySelector('#myMaxDepth')?.value || 999999, 10);
      // }

      // const matchesMeasurements = (card) => {
      //   if (!hasMeasurementFilter) return true;

      //   const pw = parseInt(card.dataset.width, 10);
      //   const ph = parseInt(card.dataset.height, 10);
      //   const pd = parseInt(card.dataset.depth, 10);

      //   const widthOk =
      //     Number.isFinite(pw) && pw > 0 && pw >= minW && pw <= maxW;
      //   const heightOk =
      //     Number.isFinite(ph) && ph > 0 && ph >= minH && ph <= maxH;
      //   const depthOk =
      //     Number.isFinite(pd) && pd > 0 && pd >= minD && pd <= maxD;

      //   return widthOk && heightOk && depthOk;
      // };

      // items.forEach(item => {
      //   const id = item.dataset.productId;
      //   if (id && existingIds.has(id)) return;
      //   if (id) existingIds.add(id);

      //   item.dataset.page = String(nextPage);

      //   if (!matchesMeasurements(item)) {
      //     item.style.display = 'none';
      //   }

      //   currentGrid.appendChild(item);
      // });

      // currentGrid.querySelectorAll('.product-card-custom').forEach(card => {
      //   card.style.display = matchesMeasurements(card) ? '' : 'none';
      // });
            // ============================================================
      // Build a complete filter matcher that checks EVERY active filter
      // (category, subcategory, measurement, price, availability, etc.)
      // Exactly the same rules as #applyAllFilters / #appendFilteredBatch.
      // ============================================================
      const filters = this.#getFilterState();

      const container = document.querySelector('.range_slide_container.active_ranges_filter');
      const hasMeasurementFilter = !!container && window.customFilterUsed === true;

      let minW = 0, maxW = Infinity;
      let minH = 0, maxH = Infinity;
      let minD = 0, maxD = Infinity;

      if (hasMeasurementFilter) {
        minW = parseInt(container.querySelector('#myMinWidth')?.value || 1, 10);
        maxW = parseInt(container.querySelector('#myMaxWidth')?.value || 999999, 10);
        minH = parseInt(container.querySelector('#myMinHeight')?.value || 1, 10);
        maxH = parseInt(container.querySelector('#myMaxHeight')?.value || 999999, 10);
        minD = parseInt(container.querySelector('#myMinDepth')?.value || 1, 10);
        maxD = parseInt(container.querySelector('#myMaxDepth')?.value || 999999, 10);
      }

      const cardMatchesAllFilters = (card) => {
        // ---------- MEASUREMENT ----------
        if (hasMeasurementFilter) {
          const pw = parseInt(card.dataset.width, 10);
          const ph = parseInt(card.dataset.height, 10);
          const pd = parseInt(card.dataset.depth, 10);

          const widthOk  = Number.isFinite(pw) && pw > 0 && pw >= minW && pw <= maxW;
          const heightOk = Number.isFinite(ph) && ph > 0 && ph >= minH && ph <= maxH;
          const depthOk  = Number.isFinite(pd) && pd > 0 && pd >= minD && pd <= maxD;

          if (!(widthOk && heightOk && depthOk)) return false;
        }

        // ---------- CATEGORY ----------
        if (filters.categories.length) {
          const haystack = [
            ...(card.dataset.allCollections || '').split(','),
            ...(card.dataset.filterCategory || '').split(','),
          ];
          if (!this.#matchesAny(haystack, filters.categories)) return false;
        }

        // ---------- SUBCATEGORY ----------
        if (filters.subcategories.length) {
          const haystack = [
            ...(card.dataset.allCollections || '').split(','),
            ...(card.dataset.filterSubCategory || '').split(','),
          ];
          if (!this.#matchesAny(haystack, filters.subcategories)) return false;
        }

        // ---------- PRICE ----------
        if (filters.priceMin || filters.priceMax) {
          const price = parseFloat(card.dataset.priceFilter) || 0;
          const min = filters.priceMin ? parseFloat(filters.priceMin) : 0;
          const max = filters.priceMax ? parseFloat(filters.priceMax) : Infinity;
          if (price < min || price > max) return false;
        }

        // ---------- AVAILABILITY ----------
        if (filters.availability.length) {
          const wantsAvailable =
            filters.availability.includes('1') ||
            filters.availability.includes('true');
          if (wantsAvailable && card.dataset.available === 'false') return false;
        }

        // ---------- VENDOR ----------
        if (filters.vendors.length) {
          const vendor = (card.dataset.vendor || '').trim();
          if (!this.#matchesAny([vendor], filters.vendors)) return false;
        }

        // ---------- PRODUCT TYPE ----------
        if (filters.productTypes.length) {
          const type = (card.dataset.productType || '').trim();
          if (!this.#matchesAny([type], filters.productTypes)) return false;
        }

        // ---------- DESIGNER ----------
        if (filters.designers.length) {
          const haystack = [
            ...(card.dataset.designer || '').split(','),
            ...(card.dataset.allCollections || '').split(','),
          ];
          if (!this.#matchesAny(haystack, filters.designers)) return false;
        }

        // ---------- MATERIALS ----------
        if (filters.materials.length) {
          const haystack = (card.dataset.materials || '').split(',');
          if (!this.#matchesAny(haystack, filters.materials)) return false;
        }

        // ---------- FEATURED ----------
        if (filters.featured.length) {
          const haystack = (card.dataset.featured || '').split(',');
          if (!this.#matchesAny(haystack, filters.featured)) return false;
        }

        return true;
      };

      items.forEach(item => {
        const id = item.dataset.productId;
        if (id && existingIds.has(id)) return;
        if (id) existingIds.add(id);

        item.dataset.page = String(nextPage);

        if (!cardMatchesAllFilters(item)) {
          item.style.display = 'none';
        } else {
          item.style.display = '';
        }

        currentGrid.appendChild(item);
      });

      // Re-evaluate EVERY card on the grid (not just new ones), so that
      // a filter change updates cards that were rendered earlier too.
      currentGrid.querySelectorAll('.product-card-custom').forEach(card => {
        card.style.display = cardMatchesAllFilters(card) ? '' : 'none';
      });

      const newPaginationInfo = newResultsList.querySelector('[data-pagination-info]');
      if (newPaginationInfo) {
        this.#hasNextPage = newPaginationInfo.dataset.hasNextPage === 'true';
        this.#totalPages = parseInt(newPaginationInfo.dataset.totalPages || '1', 10);
      } else {
        this.#hasNextPage = items.length >= 0;
      }
      this.#setupNormalInfiniteScroll();

    } catch (error) {
      console.error('❌ Normal infinite scroll error:', error);
      this.#showErrorMessage(error.message);
    } finally {
      this.#isLoading = false;
      this.removeAttribute('aria-busy');
      this.#hideLoading();
    }
  }

  // UI HELPERS

  #showCustomFilterButtons(filters) {
    document.querySelectorAll('#clearCustomFilters').forEach(element => {
      element.style.display = filters.hasMeasurementFilters ? 'flex' : 'none';
    });

    document.querySelectorAll('.price_range_clear_btn').forEach(element => {
      element.style.display =
        filters.priceMin || filters.priceMax ? 'flex' : 'none';
    });
  }

  #hideCustomFilterButtons() {
    document.querySelectorAll('#clearCustomFilters').forEach(element => {
      element.style.display = 'none';
    });
  }

  // HTML HELPERS

  #escapeHtml(value) {
    if (value === null || value === undefined) return '';
    const div = document.createElement('div');
    div.textContent = String(value);
    return div.innerHTML;
  }

  #escapeAttribute(value) {
    return this.#escapeHtml(value)
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  #escapeGraphQL(value) {
    return String(value || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"')
      .replace(/\n/g, '\\n');
  }

  // LAYOUT

  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;
    this.#animateLayoutChange(target.value);
  }

  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;
    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['product-grid']);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('product-grid-view', value);
  }

  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');

    if (!(targetElement instanceof HTMLInputElement)) return;

    targetElement.checked = true;
    this.#setLayout('default');
  };
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}